<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ $t(sidebarTitle) }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t('Title')"
              :invalid-feedback="$t('Title is required')"
            >
              <b-form-input
                :placeholder="$t('Enter title.')"
                ref="title"
                v-model="myObj.title"
                @focusout="CheckTitle()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Message')"
              :invalid-feedback="$t('Message is required.')"
              ref="msg"
            >
              <b-form-textarea
                ref="msg"
                :placeholder="$t('Enter message.')"
                v-model="myObj.message"
                @focusout="CheckMessage()"
                rows="5"
              ></b-form-textarea>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="mr-1 fullWidth"
              @click="Add()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-if="request == false"> {{ $t(sidebarButton) }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <div class="outbox-page" :class="{ 'is-loading': dataLoading }">
      <div v-if="dataLoading" class="outbox-loading-bar" aria-hidden="true" />

      <template v-if="isNotificationView">
        <div class="outbox-shell notification-dashboard">
          <section class="outbox-section-head outbox-section-head-compact">
            <div class="outbox-section-title-row">
              <div>
                <p class="outbox-section-label">{{ $t("Messages") }}</p>
                <h4 class="outbox-section-title">{{ $t("Notification Outbox") }}</h4>
              </div>
            </div>
          </section>

          <div class="demo-filter-bar outbox-filter-panel outbox-filter-bar-row">
            <div
              class="demo-filter-fields notification-filter-fields outbox-filter-left"
            >
              <div class="demo-filter-item">
                <label>{{ $t("Search") }}</label>
                <div class="filter-input-wrap">
                  <b-input-group class="outbox-search-group">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="SearchIcon" size="16" />
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="searchQuery"
                      class="outbox-search-input"
                      :placeholder="$t('Search') + '...'"
                      @input="onNotificationSearch"
                    />
                  </b-input-group>
                  <button
                    v-if="searchQuery"
                    type="button"
                    class="filter-clear-btn"
                    @click="clearSearch"
                    :aria-label="$t('Clear')"
                  >
                    <feather-icon icon="XIcon" size="14" />
                  </button>
                </div>
              </div>

              <div class="demo-filter-item">
                <label>{{ $t("Type") }}</label>
                <v-select
                  v-model="notificationFilters.metaTitle"
                  :options="metaTitleOptions"
                  :clearable="true"
                  :reduce="(val) => val.value"
                  label="label"
                  append-to-body
                  class="demo-select"
                  :placeholder="$t('All types')"
                  @input="onNotificationFilterChange"
                />
              </div>

              <div class="demo-filter-item">
                <label>{{ $t("Role") }}</label>
                <v-select
                  v-model="notificationFilters.role"
                  :options="roleOptions"
                  :clearable="true"
                  :reduce="(val) => val.value"
                  label="label"
                  append-to-body
                  class="demo-select"
                  :placeholder="$t('All roles')"
                  @input="onNotificationFilterChange"
                />
              </div>

              <div class="demo-filter-item">
                <label>{{ $t("Date Range") }}</label>
                <div class="filter-input-wrap">
                  <flat-pickr
                    v-model="rangeDate"
                    :config="dateRangeConfig"
                    class="form-control outbox-date-input"
                    :placeholder="$t('Select date range')"
                    @on-change="onDateRangeChange"
                  />
                  <button
                    v-if="rangeDate"
                    type="button"
                    class="filter-clear-btn"
                    @click="clearDateRange"
                    :aria-label="$t('Clear')"
                  >
                    <feather-icon icon="XIcon" size="14" />
                  </button>
                </div>
              </div>
            </div>

            <div class="outbox-filter-right-cluster">
              <div class="demo-filter-item outbox-filter-status">
                <label>{{ $t("Type") }}</label>
                <v-select
                  v-model="currentStatus"
                  :disabled="deleting"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="statusOptions"
                  :clearable="false"
                  label="text"
                  :reduce="(val) => val.value"
                  append-to-body
                  @input="onStatusChange()"
                  :placeholder="$t('Select type')"
                  class="demo-select"
                />
              </div>
              <button
                type="button"
                class="demo-excel-btn outbox-refresh-btn"
                :disabled="dataLoading || deleting"
                @click="loadNotificationDashboard()"
              >
                <feather-icon
                  icon="RefreshCcwIcon"
                  size="16"
                  class="mr-50"
                  :class="{ 'spin-icon': dataLoading }"
                />
                {{ $t("Refresh") }}
              </button>
            </div>
          </div>

          <div class="demo-kpi-grid notification-kpi-grid outbox-kpi-section">
            <div
              v-for="card in notificationKpiCards"
              :key="card.key"
              class="demo-kpi-card is-clickable"
              :class="[
                'accent-' + card.accent,
                { 'is-active': notificationFilters.isSeen === card.filterValue },
              ]"
              role="button"
              tabindex="0"
              @click="setIsSeenFilter(card.filterValue)"
              @keydown.enter.prevent="setIsSeenFilter(card.filterValue)"
            >
              <div class="demo-kpi-top">
                <div class="demo-kpi-icon" :class="'icon-' + card.accent">
                  <feather-icon :icon="card.icon" size="18" />
                </div>
              </div>
              <div class="demo-kpi-value">{{ formatNumber(card.value) }}</div>
              <div class="demo-kpi-label">{{ $t(card.label) }}</div>
            </div>
          </div>

          <section class="demo-card demo-table-card outbox-table-card">
            <div class="demo-card-head">
              <span class="demo-card-icon purple">
                <feather-icon icon="BellIcon" size="16" />
              </span>
              <h5>{{ $t("Notifications") }}</h5>
            </div>

            <div class="pagination-controls-top outbox-pagination-top">
              <div class="d-flex align-items-center gap-2 flex-wrap">
                <div class="page-size-wrapper">
                  <label class="page-size-label">{{ $t("Show") }}:</label>
                  <v-select
                    v-model="notificationPageSize"
                    :options="pageSizeOptions"
                    :reduce="(option) => option.value"
                    label="label"
                    :clearable="false"
                    :searchable="false"
                    append-to-body
                    class="page-size-select-compact"
                    @input="onNotificationPageSizeChange"
                  />
                </div>
              </div>

              <div class="pagination-count-display">
                <span class="count-text">
                  {{ $t("Showing") }}
                  <strong>{{ notificationDisplayedRange.start }}</strong>
                  {{ $t("to") }}
                  <strong>{{ notificationDisplayedRange.end }}</strong>
                  {{ $t("of") }}
                  <strong>{{ formatNumber(notificationFilteredTotal) }}</strong>
                </span>
              </div>

              <div class="pagination-wrapper-compact">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="notificationFilteredTotal"
                  :per-page="notificationPageSize"
                  size="sm"
                  align="center"
                  class="pagination-compact mb-0"
                  @input="onNotificationPageChange"
                />
              </div>
            </div>

            <div class="demo-table-wrap outbox-table-wrap">
              <b-table
                class="outbox-table notification-table"
                ref="notificationTable"
                :items="items"
                :fields="notificationFields"
                :busy="dataLoading"
                show-empty
                responsive
                hover
                sticky-header="520px"
              >
                <template #empty>
                  <div v-if="!dataLoading" class="outbox-empty-state">
                    <span class="outbox-empty-icon">
                      <feather-icon icon="InboxIcon" size="28" />
                    </span>
                    <h4>{{ $t("No records found") }}</h4>
                    <p>{{ $t("Try adjusting your filters or date range.") }}</p>
                  </div>
                </template>

                <template #table-busy>
                  <div class="outbox-table-skeleton">
                    <table class="demo-table outbox-skeleton-table">
                      <tbody>
                        <tr
                          v-for="n in skeletonRowCount"
                          :key="'skel-notif-' + n"
                          class="skel-row"
                          :style="{ '--skel-delay': (n - 1) * 0.06 + 's' }"
                        >
                          <td><span class="skel-bone skel-avatar" /></td>
                          <td><span class="skel-bone skel-w-lg" /></td>
                          <td><span class="skel-bone skel-w-md" /></td>
                          <td><span class="skel-bone skel-w-xl" /></td>
                          <td><span class="skel-bone skel-pill" /></td>
                          <td><span class="skel-bone skel-pill" /></td>
                          <td><span class="skel-bone skel-pill" /></td>
                          <td class="text-right"><span class="skel-bone skel-btn-sm" /></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>

                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template #head(actions)="data">
                  <div class="text-right pr-1">
                    <span>{{ $t(data.label) }}</span>
                  </div>
                </template>

                <template #cell(profile)="data">
                  <b-img
                    v-if="data.value"
                    rounded
                    :src="data.value"
                    height="44px"
                    width="44px"
                    alt=""
                    class="notification-avatar"
                  />
                  <b-avatar v-else size="44" variant="light-primary" />
                </template>

                <template #cell(name)="data">
                  <span class="notification-name">{{ data.value || "-" }}</span>
                </template>

                <template #cell(date)="data">
                  <span class="outbox-date-text">
                    {{ formatNotificationDate(data.value) }}
                  </span>
                </template>

                <template #cell(message)="data">
                  <span class="notification-message">{{ data.value || "-" }}</span>
                </template>

                <template #cell(metaTitle)="data">
                  <span class="outbox-type-pill">
                    {{ formatMetaTitle(data.value) }}
                  </span>
                </template>

                <template #cell(role)="data">
                  <span class="outbox-role-pill">
                    {{ getRoleLabel(data.value) }}
                  </span>
                </template>

                <template #cell(isSeen)="data">
                  <span
                    class="outbox-status-pill"
                    :class="data.value ? 'is-seen' : 'is-not-seen'"
                  >
                    {{ formatIsSeen(data.value) }}
                  </span>
                </template>

                <template #cell(actions)="data">
                  <b-button
                    v-if="rights.delete"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-danger"
                    v-b-tooltip.hover.right
                    :title="$t('Delete')"
                    class="btn-icon outbox-delete-btn"
                    @click="Delete(data.item)"
                  >
                    <feather-icon icon="Trash2Icon" size="16" />
                  </b-button>
                </template>
              </b-table>
            </div>
          </section>
        </div>
      </template>

      <template v-else>
        <div class="outbox-shell outbox-legacy">
          <section class="outbox-section-head">
            <p class="outbox-section-label">{{ $t("Messages") }}</p>
            <h4 class="outbox-section-title">
              {{
                currentStatus == "sent"
                  ? $t("Messages")
                  : $t("Outbox")
              }}
            </h4>
          </section>

          <div
            class="demo-filter-bar outbox-filter-panel outbox-legacy-filter-bar outbox-filter-bar-row"
            :class="{ 'outbox-legacy-filter-bar--sent': isSentBoxView }"
          >
            <div
              v-if="isSentBoxView"
              class="demo-filter-fields outbox-sent-filter-fields outbox-filter-left"
            >
              <div class="demo-filter-item outbox-sent-date-field">
                <label>{{ $t("Date Range") }}</label>
                <div class="filter-input-wrap">
                  <flat-pickr
                    v-model="sentBoxDateRange"
                    :config="dateRangeConfig"
                    class="form-control outbox-date-input"
                    :placeholder="$t('Select date range')"
                    @on-change="onSentBoxDateRangeChange"
                  />
                  <button
                    v-if="sentBoxDateRange"
                    type="button"
                    class="filter-clear-btn"
                    @click="clearSentBoxDateRange"
                    :aria-label="$t('Clear')"
                  >
                    <feather-icon icon="XIcon" size="14" />
                  </button>
                </div>
              </div>

              <div class="demo-filter-item outbox-filter-status">
                <label>{{ $t("Message status") }}</label>
                <v-select
                  v-model="sentBoxStatus"
                  :disabled="deleting || dataLoading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="sentBoxMessageStatusOptions"
                  :clearable="false"
                  label="text"
                  :reduce="(val) => val.value"
                  append-to-body
                  class="demo-select"
                  @input="onSentBoxStatusFilterChange"
                />
              </div>
            </div>

            <div
              v-if="isSentBoxView"
              class="outbox-filter-right-cluster"
            >
              <div class="demo-filter-item outbox-filter-status">
                <label>{{ $t("Type") }}</label>
                <v-select
                  v-model="currentStatus"
                  :disabled="deleting"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="statusOptions"
                  :clearable="false"
                  label="text"
                  :reduce="(val) => val.value"
                  append-to-body
                  @input="onStatusChange()"
                  :placeholder="$t('Select type')"
                  class="demo-select"
                />
              </div>
              <button
                type="button"
                class="demo-excel-btn outbox-refresh-btn"
                :disabled="dataLoading || deleting"
                @click="onOutboxRefresh()"
              >
                <feather-icon
                  icon="RefreshCcwIcon"
                  size="16"
                  class="mr-50"
                  :class="{ 'spin-icon': dataLoading }"
                />
                {{ $t("Refresh") }}
                ({{ formatNumber(sentBoxFilteredTotal) }})
              </button>
              <button
                v-if="showMoveToQueueForMessages"
                type="button"
                class="demo-excel-btn outbox-move-queue-btn"
                :disabled="
                  dataLoading || deleting || moveToQueueActionCount === 0
                "
                v-b-tooltip.hover.top
                :title="moveToQueueButtonTitle"
                @click="sendQueue('message')"
              >
                <b-spinner v-if="deleting" small type="grow" class="mr-50" />
                <feather-icon
                  v-else
                  icon="SendIcon"
                  size="16"
                  class="mr-50"
                />
                {{ $t("Move to Queue") }}
                ({{ formatNumber(moveToQueueActionCount) }})
              </button>
              <button
                v-if="showOutboxClearButton"
                type="button"
                class="outbox-icon-btn outbox-icon-btn-danger"
                :disabled="dataLoading || deleting"
                v-b-tooltip.hover.top
                :title="outboxClearButtonTitle"
                @click="deleteAll()"
              >
                <feather-icon icon="Trash2Icon" size="16" />
              </button>
            </div>

            <template v-else>
            <div
              class="demo-filter-fields outbox-legacy-filter-fields outbox-filter-left"
              :class="{ 'outbox-legacy-filter-fields--challan': currentStatus == 'challan' }"
            >
              <div class="demo-filter-item">
                <label>{{ $t("Search") }}</label>
                <div class="filter-input-wrap">
                  <b-input-group class="outbox-search-group">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="SearchIcon" size="16" />
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="searchQuery"
                      class="outbox-search-input"
                      :placeholder="
                        isLegacyServerPaged
                          ? $t('Search number or message') + '...'
                          : $t('Search') + '...'
                      "
                      @input="onLegacySearch"
                    />
                  </b-input-group>
                  <button
                    v-if="searchQuery"
                    type="button"
                    class="filter-clear-btn"
                    @click="clearLegacySearch"
                    :aria-label="$t('Clear')"
                  >
                    <feather-icon icon="XIcon" size="14" />
                  </button>
                </div>
              </div>

              <div
                v-if="currentStatus == 'challan'"
                class="demo-filter-item outbox-filter-status"
              >
                <label>{{ $t("Message status") }}</label>
                <v-select
                  v-model="challanStatus"
                  :disabled="deleting || dataLoading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="challanMessageStatusOptions"
                  :clearable="false"
                  label="text"
                  :reduce="(val) => val.value"
                  append-to-body
                  class="demo-select"
                  @input="onChallanStatusFilterChange"
                />
              </div>

              <div v-if="currentStatus == 'challan'" class="demo-filter-item">
                <label>{{ $t("Date Range") }}</label>
                <div class="filter-input-wrap">
                  <flat-pickr
                    v-model="challanDateRange"
                    :config="dateRangeConfig"
                    class="form-control outbox-date-input"
                    :placeholder="$t('Select date range')"
                    @on-change="onChallanDateRangeChange"
                  />
                  <button
                    v-if="challanDateRange"
                    type="button"
                    class="filter-clear-btn"
                    @click="clearChallanDateRange"
                    :aria-label="$t('Clear')"
                  >
                    <feather-icon icon="XIcon" size="14" />
                  </button>
                </div>
              </div>
            </div>

            <div class="outbox-filter-right-cluster">
              <div class="demo-filter-item outbox-filter-status">
                <label>{{ $t("Type") }}</label>
                <v-select
                  v-model="currentStatus"
                  :disabled="deleting"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="statusOptions"
                  :clearable="false"
                  label="text"
                  :reduce="(val) => val.value"
                  append-to-body
                  @input="onStatusChange()"
                  :placeholder="$t('Select type')"
                  class="demo-select"
                />
              </div>
              <div class="outbox-legacy-actions">
                <button
                  type="button"
                  class="demo-excel-btn outbox-refresh-btn"
                  :disabled="dataLoading || deleting"
                  @click="onOutboxRefresh()"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    size="16"
                    class="mr-50"
                    :class="{ 'spin-icon': dataLoading }"
                  />
                  {{ $t("Refresh") }}
                  {{
                    currentStatus == "queue"
                      ? `(${queueCount})`
                      : currentStatus == "challan"
                      ? `(${formatNumber(challanFilteredTotal)})`
                      : currentStatus == "sent"
                      ? `(${formatNumber(sentBoxFilteredTotal)})`
                      : `(${items.length})`
                  }}
                </button>
                <button
                  v-if="showMoveToQueueForChallan"
                  type="button"
                  class="demo-excel-btn outbox-move-queue-btn"
                  :disabled="
                    dataLoading || deleting || moveToQueueActionCount === 0
                  "
                  v-b-tooltip.hover.top
                  :title="moveToQueueButtonTitle"
                  @click="sendQueue('challan')"
                >
                  <b-spinner v-if="deleting" small type="grow" class="mr-50" />
                  <feather-icon
                    v-else
                    icon="SendIcon"
                    size="16"
                    class="mr-50"
                  />
                  {{ $t("Move to Queue") }}
                  ({{ formatNumber(moveToQueueActionCount) }})
                </button>
                <button
                  v-if="showOutboxClearButton"
                  type="button"
                  class="outbox-icon-btn outbox-icon-btn-danger"
                  :disabled="dataLoading || deleting"
                  v-b-tooltip.hover.top
                  :title="outboxClearButtonTitle"
                  @click="deleteAll()"
                >
                  <feather-icon icon="Trash2Icon" size="16" />
                </button>
              </div>
            </div>
            </template>
          </div>

          <div
            v-if="isSentBoxView"
            class="demo-kpi-grid outbox-challan-kpi-grid outbox-sentbox-kpi-grid"
          >
            <div
              v-for="card in sentKpiCards"
              :key="card.key"
              class="demo-kpi-card is-clickable"
              :class="[
                'accent-' + card.accent,
                {
                  'is-active': sentBoxStatus === card.filterValue,
                  'is-loading-stats': isSentBoxCardLoading(card),
                },
              ]"
              role="button"
              tabindex="0"
              :aria-busy="isSentBoxCardLoading(card) ? 'true' : 'false'"
              @click="setSentBoxStatusFilter(card.filterValue)"
              @keydown.enter.prevent="setSentBoxStatusFilter(card.filterValue)"
            >
              <div class="demo-kpi-top">
                <div class="demo-kpi-icon" :class="'icon-' + card.accent">
                  <b-spinner
                    v-if="isSentBoxCardLoading(card)"
                    small
                    type="grow"
                    class="demo-kpi-icon-spinner"
                  />
                  <feather-icon v-else :icon="card.icon" size="18" />
                </div>
              </div>
              <div class="demo-kpi-value">
                <span
                  v-if="isSentBoxCardLoading(card)"
                  class="demo-kpi-value-shimmer"
                  aria-hidden="true"
                />
                <template v-else>{{ formatNumber(card.value) }}</template>
              </div>
              <div class="demo-kpi-label">{{ $t(card.label) }}</div>
            </div>
          </div>

          <div
            v-if="currentStatus == 'challan'"
            class="demo-kpi-grid outbox-challan-kpi-grid"
          >
            <div
              v-for="card in challanKpiCards"
              :key="card.key"
              class="demo-kpi-card is-clickable"
              :class="[
                'accent-' + card.accent,
                {
                  'is-active': challanStatus === card.filterValue,
                  'is-loading-stats': isChallanCardLoading(card),
                },
              ]"
              role="button"
              tabindex="0"
              :aria-busy="isChallanCardLoading(card) ? 'true' : 'false'"
              @click="setChallanStatusFilter(card.filterValue)"
              @keydown.enter.prevent="setChallanStatusFilter(card.filterValue)"
            >
              <div class="demo-kpi-top">
                <div class="demo-kpi-icon" :class="'icon-' + card.accent">
                  <b-spinner
                    v-if="isChallanCardLoading(card)"
                    small
                    type="grow"
                    class="demo-kpi-icon-spinner"
                  />
                  <feather-icon v-else :icon="card.icon" size="18" />
                </div>
              </div>
              <div class="demo-kpi-value">
                <span
                  v-if="isChallanCardLoading(card)"
                  class="demo-kpi-value-shimmer"
                  aria-hidden="true"
                />
                <template v-else>{{ formatNumber(card.value) }}</template>
              </div>
              <div class="demo-kpi-label">{{ $t(card.label) }}</div>
            </div>
          </div>

          <section class="demo-card demo-table-card outbox-table-card">
            <div class="demo-card-head">
              <span class="demo-card-icon purple">
                <feather-icon icon="MailIcon" size="16" />
              </span>
              <h5>{{ $t("Messages") }}</h5>
            </div>

            <div class="pagination-controls-top outbox-pagination-top">
              <div class="d-flex align-items-center gap-2 flex-wrap">
                <div class="page-size-wrapper">
                  <label class="page-size-label">{{ $t("Show") }}:</label>
                  <v-select
                    v-model="perPage"
                    :options="pageSizeOptions"
                    :reduce="(option) => option.value"
                    label="label"
                    :clearable="false"
                    :searchable="false"
                    append-to-body
                    class="page-size-select-compact"
                    @input="onLegacyPageSizeChange"
                  />
                </div>
              </div>

              <div class="pagination-count-display">
                <span class="count-text">
                  {{ $t("Showing") }}
                  <strong>{{ legacyDisplayedRange.start }}</strong>
                  {{ $t("to") }}
                  <strong>{{ legacyDisplayedRange.end }}</strong>
                  {{ $t("of") }}
                  <strong>{{ formatNumber(legacyPaginationTotal) }}</strong>
                </span>
              </div>

              <div class="pagination-wrapper-compact">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="legacyPaginationTotal"
                  :per-page="perPage"
                  size="sm"
                  align="center"
                  class="pagination-compact mb-0"
                  @input="onLegacyPageChange"
                />
              </div>
            </div>

            <div class="demo-table-wrap outbox-table-wrap">
              <b-table
                class="outbox-table"
                ref="selectableTable"
                :items="legacyTableItems"
                :fields="legacyTableFields"
                :current-page="isLegacyServerPaged ? 1 : currentPage"
                :per-page="isLegacyServerPaged ? legacyTableItems.length || 1 : perPage"
                :busy="dataLoading"
                show-empty
                responsive
                hover
                sticky-header="520px"
              >
                <template #empty>
                  <div v-if="!dataLoading" class="outbox-empty-state">
                    <span class="outbox-empty-icon">
                      <feather-icon icon="InboxIcon" size="28" />
                    </span>
                    <h4>{{ $t("No records found") }}</h4>
                    <p>{{ $t("Try adjusting your search or status filter.") }}</p>
                  </div>
                </template>

                <template #table-busy>
                  <div class="outbox-table-skeleton">
                    <table class="demo-table outbox-skeleton-table">
                      <tbody>
                        <tr
                          v-for="n in skeletonRowCount"
                          :key="'skel-legacy-' + n"
                          class="skel-row"
                          :style="{ '--skel-delay': (n - 1) * 0.06 + 's' }"
                        >
                          <td><span class="skel-bone skel-avatar" /></td>
                          <td><span class="skel-bone skel-w-lg" /></td>
                          <td><span class="skel-bone skel-w-md" /></td>
                          <td><span class="skel-bone skel-w-xl" /></td>
                          <td><span class="skel-bone skel-w-sm" /></td>
                          <td class="text-right"><span class="skel-bone skel-btn-sm" /></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>

                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template #head(_queueSelect)>
                  <b-form-checkbox
                    v-if="canSelectForMoveToQueue"
                    :checked="isAllQueueRowsSelectedOnPage"
                    :indeterminate="isQueueRowsIndeterminateOnPage"
                    @change="toggleSelectAllQueueRowsOnPage"
                  />
                </template>

                <template #head(actions)="data">
                  <div class="text-right pr-1">
                    <span>{{ $t(data.label) }}</span>
                  </div>
                </template>

                <template #cell(_queueSelect)="data">
                  <b-form-checkbox
                    v-if="isRowEligibleForMoveToQueue(data.item)"
                    :checked="isQueueRowSelected(data.item.id)"
                    @change="(checked) => toggleQueueRowSelection(data.item, checked)"
                  />
                </template>

                <template #cell(meta_avatar)="data">
                  <b-img
                    v-if="data.value !== null && data.value !== ''"
                    rounded
                    :src="data.value"
                    height="44px"
                    width="44px"
                    alt=""
                    class="notification-avatar"
                  />
                  <b-img
                    v-else
                    src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                    height="44px"
                    width="44px"
                    class="notification-avatar"
                  />
                </template>

                <template #cell(date)="data">
                  <span class="outbox-date-text">
                    {{
                      new Date(data.item.date).toLocaleDateString("en-UK", {
                        year: "numeric",
                        day: "numeric",
                        month: "short",
                      })
                    }}
                  </span>
                </template>

                <template #cell(meta_subtitle)="data">
                  <span class="outbox-subtitle-text">{{
                    data.item.meta_subtitle || "—"
                  }}</span>
                </template>

                <template #cell(status)="data">
                  <b-badge variant="light-success" class="text-capitalize">
                    {{ data.item.status || "—" }}
                  </b-badge>
                </template>

                <template #cell(role)="data">
                  <span class="outbox-role-pill text-capitalize">{{
                    data.item.role || "—"
                  }}</span>
                </template>

                <template #cell(media)="data">
                  <a
                    v-if="data.item.media"
                    :href="data.item.media"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="outbox-media-link"
                  >
                    {{ $t("View") }}
                  </a>
                  <span v-else class="text-muted">—</span>
                </template>

                <template #cell(actions)="data">
                  <b-button
                    v-if="showOutboxRowDelete"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-danger"
                    v-b-tooltip.hover.right
                    :title="$t('Delete')"
                    class="btn-icon outbox-delete-btn"
                    @click="Delete(data.item)"
                  >
                    <feather-icon icon="Trash2Icon" size="16" />
                  </b-button>
                </template>
              </b-table>
            </div>
          </section>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormGroup,
  BForm,
  BMediaAside,
  BMediaBody,
  BSpinner,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BFormTextarea,
  BAvatar,
  BFormCheckbox,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  components: {
    BAvatar,
    BFormTextarea,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BForm,
    BPagination,
    BSpinner,
    BImg,
    BMedia,
    BMediaAside,
    BMediaBody,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    if (!this.$store.state.rights[this.$route.name]) {
      // console.log(this.$store.state.rights[this.$route.name]);
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      // console.log(this.rights);
      this.LoadData();
      this.loadMoveToQueueSetting();
    }
  },
  computed: {
    showMoveToQueue() {
      return !!this.moveToQueueEnabled;
    },
    /** Messages tab: Pending (dbPending), same setting as challan `move_to_queue`. */
    showMoveToQueueForMessages() {
      return (
        this.showMoveToQueue &&
        this.isSentBoxView &&
        this.sentBoxStatus === "dbPending"
      );
    },
    showMoveToQueueForChallan() {
      return (
        this.showMoveToQueue &&
        this.currentStatus === "challan" &&
        this.challanStatus === "pending"
      );
    },
    canSelectForMoveToQueue() {
      return (
        this.showMoveToQueueForMessages || this.showMoveToQueueForChallan
      );
    },
    eligibleMoveToQueueItemsOnPage() {
      return (this.legacyTableItems || []).filter((item) =>
        this.isRowEligibleForMoveToQueue(item)
      );
    },
    isAllQueueRowsSelectedOnPage() {
      const eligible = this.eligibleMoveToQueueItemsOnPage;
      if (!eligible.length) return false;
      return eligible.every((item) =>
        this.moveToQueueSelectedIds.includes(item.id)
      );
    },
    isQueueRowsIndeterminateOnPage() {
      const eligible = this.eligibleMoveToQueueItemsOnPage;
      if (!eligible.length) return false;
      const selectedOnPage = eligible.filter((item) =>
        this.moveToQueueSelectedIds.includes(item.id)
      ).length;
      return selectedOnPage > 0 && selectedOnPage < eligible.length;
    },
    moveToQueueSelectionCount() {
      return (this.moveToQueueSelectedIds || []).length;
    },
    moveToQueueActionCount() {
      if (this.moveToQueueSelectionCount > 0) {
        return this.moveToQueueSelectionCount;
      }
      if (this.showMoveToQueueForMessages) {
        return this.sentBoxFilteredTotal || this.items.length;
      }
      if (this.showMoveToQueueForChallan) {
        return this.challanFilteredTotal || this.items.length;
      }
      return 0;
    },
    moveToQueueButtonTitle() {
      if (this.moveToQueueSelectionCount > 0) {
        return this.$t("Move selected pending messages to queue");
      }
      if (this.showMoveToQueueForChallan) {
        return this.$t("Move pending challan messages to queue");
      }
      return this.$t("Move pending messages to queue");
    },
    /** Clear all: Messages → Processing (pending) only; Challan → Pending tab only. */
    showOutboxClearButton() {
      if (!this.rights || !this.rights.delete) return false;
      if (this.currentStatus === "queue") return false;
      if (this.currentStatus === "challanNotification") return false;
      if (this.currentStatus === "sent") {
        return this.sentBoxStatus === "pending";
      }
      if (this.currentStatus === "challan") {
        return this.challanStatus === "pending";
      }
      return true;
    },
    showOutboxRowDelete() {
      if (!this.rights || !this.rights.delete) return false;
      if (this.isDetails || this.currentStatus === "queue") return false;
      if (this.isSentBoxView) {
        return this.sentBoxStatus === "pending";
      }
      return true;
    },
    outboxClearButtonTitle() {
      if (this.currentStatus === "draft") {
        return (
          this.$t("Clear Draft") + ` (${this.items.length})`
        );
      }
      if (this.currentStatus === "challan") {
        return (
          this.$t("Clear Challan") +
          ` (${this.formatNumber(
            this.challanFilteredTotal || this.items.length
          )})`
        );
      }
      if (this.currentStatus === "sent") {
        return (
          this.$t("Clear Outbox") +
          ` (${this.formatNumber(
            this.sentBoxFilteredTotal || this.items.length
          )})`
        );
      }
      return this.$t("Clear Outbox") + ` (${this.items.length})`;
    },
    isNotificationView() {
      return this.currentStatus === "challanNotification";
    },
    isChallanView() {
      return this.currentStatus === "challan";
    },
    isSentBoxView() {
      return this.currentStatus === "sent";
    },
    isLegacyServerPaged() {
      return this.isChallanView || this.isSentBoxView;
    },
    filters() {
      if (this.isLegacyServerPaged) return this.items;
      const query = String(this.searchQuery || "").toLowerCase();
      if (!query) return this.items;
      return this.items.filter((pro) => {
        return (
          (pro.meta_title &&
            pro.meta_title.toLowerCase().match(query)) ||
          (pro.message && pro.message.toLowerCase().match(query)) ||
          (pro.number && String(pro.number).toLowerCase().match(query))
        );
      });
    },
    legacyTableItems() {
      return this.isLegacyServerPaged ? this.items : this.filters;
    },
    legacyTableFields() {
      let list;
      if (this.isSentBoxView) {
        list = [...this.sentChatFields];
      } else if (this.isChallanView) {
        list = this.fields.filter((field) => field.key !== "actions");
      } else {
        list = [...this.fields];
      }
      if (this.canSelectForMoveToQueue) {
        return [
          { key: "_queueSelect", label: "", thStyle: { width: "42px" } },
          ...list,
        ];
      }
      return list;
    },
    sentChatFields() {
      return [
        { label: "profile", key: "meta_avatar" },
        { label: "name", key: "meta_title" },
        { label: "GR / ID", key: "meta_subtitle" },
        { label: "date", key: "date" },
        { label: "number", key: "number" },
        { label: "role", key: "role" },
        { label: "message", key: "message" },
        { label: "attachment", key: "media" },
      ];
    },
    legacyPaginationTotal() {
      if (this.isChallanView) return this.challanFilteredTotal;
      if (this.isSentBoxView) return this.sentBoxFilteredTotal;
      return this.filters.length;
    },
    sentKpiCards() {
      return [
        {
          key: "pending",
          label: "Pending",
          value: this.sentSummaryObj.dbPending,
          icon: "ClockIcon",
          accent: "orange",
          filterValue: "dbPending",
        },
        {
          key: "processing",
          label: "Processing",
          value: this.sentSummaryObj.processing,
          icon: "LoaderIcon",
          accent: "blue",
          filterValue: "pending",
        },
        {
          key: "sent",
          label: "Sent",
          value: this.sentSummaryObj.sent,
          icon: "CheckCircleIcon",
          accent: "green",
          filterValue: "sent",
        },
        {
          key: "failed",
          label: "Failed",
          value: this.sentSummaryObj.failed,
          icon: "AlertCircleIcon",
          accent: "pink",
          filterValue: "error",
        },
      ];
    },
    challanKpiCards() {
      return [
        {
          key: "notProcessing",
          label: "Processing",
          value: this.summaryObj.notProcessing,
          icon: "PauseCircleIcon",
          accent: "blue",
          filterValue: "not-processing",
        },
        {
          key: "pending",
          label: "Pending",
          value: this.summaryObj.pending,
          icon: "ClockIcon",
          accent: "orange",
          filterValue: "pending",
        },
        {
          key: "sent",
          label: "Sent",
          value: this.summaryObj.sent,
          icon: "CheckCircleIcon",
          accent: "green",
          filterValue: "sent",
        },
        {
          key: "error",
          label: "Not on WhatsApp",
          value: this.summaryObj.error,
          icon: "AlertCircleIcon",
          accent: "pink",
          filterValue: "error",
        },
      ];
    },
    notificationKpiCards() {
      return [
        {
          key: "total",
          label: "Total",
          value: this.notificationSummary.total,
          icon: "LayersIcon",
          accent: "purple",
          filterValue: null,
        },
        {
          key: "seen",
          label: "Seen",
          value: this.notificationSummary.seen,
          icon: "EyeIcon",
          accent: "green",
          filterValue: true,
        },
        {
          key: "notSeen",
          label: "Not seen",
          value: this.notificationSummary.notSeen,
          icon: "EyeOffIcon",
          accent: "orange",
          filterValue: false,
        },
      ];
    },
    notificationDisplayedRange() {
      const total = this.notificationFilteredTotal || 0;
      if (!total) return { start: 0, end: 0 };
      const start = (this.currentPage - 1) * this.notificationPageSize + 1;
      const end = Math.min(this.currentPage * this.notificationPageSize, total);
      return { start, end };
    },
    legacyDisplayedRange() {
      const total = this.legacyPaginationTotal || 0;
      if (!total) return { start: 0, end: 0 };
      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, total);
      return { start, end };
    },
    skeletonRowCount() {
      const pageSize = this.isNotificationView
        ? this.notificationPageSize
        : this.perPage;
      return Math.max(Number(pageSize) || 10, 6);
    },
  },
  data() {
    return {
      rights: {},
      request: false,
      sidebarTitle: "Add Template",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      isDetails: false,
      deleting: false,
      visibility: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      currentStatus: "sent",
      notificationPageSize: 20,
      notificationFilteredTotal: 0,
      notificationTotalPages: 1,
      pageSizeOptions: [
        { label: "10", value: 10 },
        { label: "20", value: 20 },
        { label: "50", value: 50 },
        { label: "100", value: 100 },
        { label: "200", value: 200 },
      ],
      challanStatus: "pending",
      challanFilteredTotal: 0,
      challanPostgresStatsLoading: false,
      challanPostgresStatsReady: false,
      challanCache: {},
      challanPrefetchId: 0,
      challanStatusTabs: ["not-processing", "pending", "sent", "error"],
      challanDateRange: "",
      challanFilters: {
        dtFrom: "",
        dtTo: "",
      },
      challanMessageStatusOptions: [
        { text: "Processing", value: "not-processing" },
        { text: "Pending", value: "pending" },
        { text: "Sent", value: "sent" },
        { text: "Not on WhatsApp", value: "error" },
      ],
      sentBoxStatus: "dbPending",
      sentBoxFilteredTotal: 0,
      sentBoxStatsLoading: false,
      sentBoxStatsReady: false,
      sentBoxCache: {},
      sentBoxPrefetchId: 0,
      sentBoxStatusTabs: ["dbPending", "pending", "sent", "error"],
      sentBoxDateRange: "",
      sentBoxFilters: {
        dtFrom: "",
        dtTo: "",
      },
      sentBoxMessageStatusOptions: [
        { text: "Pending", value: "dbPending" },
        { text: "Processing", value: "pending" },
        { text: "Sent", value: "sent" },
        { text: "Failed", value: "error" },
      ],
      sentSummaryObj: {
        processing: 0,
        dbPending: 0,
        sent: 0,
        failed: 0,
        total: 0,
      },
      metaTitleOptions: [],
      roleOptions: [],
      notificationFiltersLoaded: false,
      notificationFilters: {
        metaTitle: null,
        role: null,
        isSeen: null,
        dtFrom: "",
        dtTo: "",
      },
      dateRangeConfig: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
        static: false,
      },
      searchTimer: null,
      loadRequestId: 0,
      notificationFields: [
        { label: "profile", key: "profile", tdClass: "notification-profile-cell" },
        { label: "name", key: "name", tdClass: "notification-name-cell" },
        { label: "date", key: "date", tdClass: "notification-date-cell" },
        { label: "message", key: "message", tdClass: "notification-message-cell" },
        { label: "type", key: "metaTitle", tdClass: "notification-type-cell" },
        { label: "role", key: "role", tdClass: "notification-role-cell" },
        { label: "status", key: "isSeen", tdClass: "notification-status-cell" },
        { key: "actions", label: "actions", tdClass: "text-right" },
      ],
      notificationSummary: {
        total: 0,
        seen: 0,
        notSeen: 0,
      },
      statusOptions: [
        // { text: "Pending", value: "pending" },
        // { text: "Draft", value: "draft" },
        { text: "Messages", value: "sent" },
        { text: "Challan", value: "challan" },
        { text: "Notification", value: "challanNotification" },
        // { text: "Queue", value: "queue" },
      ],
      errors: {
        status: false,
      },

      index: null,

      fields: [
        { label: "profile", key: "meta_avatar" },
        { label: "name", key: "meta_title" },
        { label: "date", key: "date" },
        { label: "message", key: "message" },
        { label: "number", key: "number" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      selected: null,
      rangeDate: "",
      myObj: {
        id: 0,
        title: "",
        message: "",
        campusID: this.$store.state.userData.cId,
      },
      pauseObj: null,
      pausing: false,
      moveToQueueEnabled: false,
      moveToQueueSelectedIds: [],
      lastSilentMoveToQueueAt: 0,
      silentMoveToQueueCooldownMs: 5 * 60 * 1000,
      summaryObj: {
        error: 0,
        pending: 0,
        sent: 0,
        notProcessing: 0,
        total: 0,
      },
      queueCount: 0,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    async LoadSetting() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["whatsapp_pause"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });

      let obj = res.find((el) => el.key == "whatsapp_pause");
      if (!obj) {
        this.pauseObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "whatsapp_pause",
          value: "whatsapp_pause",
          valueBool: false,
          valueNumber: null,
        };
      } else this.pauseObj = obj;
    },

    async loadMoveToQueueSetting() {
      this.moveToQueueEnabled = false;
      try {
        const res = await this.post({
          url:
            this.$store.state.domain +
            "Settings/getSettingsAll?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: ["move_to_queue"],
          context: this,
          token: this.$store.state.userData.token,
          subjects: true,
        });
        const list = Array.isArray(res) ? res : [];
        const obj = list.find(
          (el) =>
            String((el && el.key) || "")
              .trim()
              .toLowerCase() === "move_to_queue"
        );
        this.moveToQueueEnabled = !!(obj && obj.valueBool === true);
      } catch (e) {
        console.error(e);
        this.moveToQueueEnabled = false;
      }
    },
    async saveSetting() {
      let obj = { ...this.pauseObj };
      obj.valueBool = !obj.valueBool;
      let msg = `WhatsApp ${
        obj.valueBool ? "paused" : "resumed"
      } updated successfully.`;

      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: `Do you want to ${obj.valueBool ? "pause" : "resume"} WhatsApp?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });
      if (result.isConfirmed) {
        this.pausing = true;

        var status = await this.post({
          url:
            this.$store.state.domain +
            "Settings/SaveNew?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: [obj],
          message: msg,
          context: this,
          token: this.$store.state.userData.token,
        });
        this.pausing = false;
        if (status) {
          this.LoadSetting();
        }
      }
    },

    async Edit(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "MessageTemplate/GetSelected?id=" +
          id +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      this.myObj = await this.get(obj);
      // console.log("editObj:", this.myObj);

      var elem = this.$refs["title"];
      elem.state = undefined;
      var elem = this.$refs["msg"];
      elem.state = undefined;

      this.sidebarTitle = "Edit Template";
      this.sidebarButton = "Update";
      this.visibility = true;
    },

    AddOpen() {
      this.myObj = {
        id: 0,
        title: "",
        message: "",
        campusID: this.$store.state.userData.cId,
      };
      var elem = this.$refs["title"];
      elem.state = undefined;
      var elem = this.$refs["msg"];
      elem.state = undefined;

      this.sidebarTitle = "Add Template";
      this.sidebarButton = "Save";
      this.visibility = true;
    },

    CheckTitle() {
      var elem = this.$refs["title"];
      if (this.myObj.title == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckMessage() {
      var elem = this.$refs["msg"];
      if (this.myObj.message == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    hideSideBar() {
      this.visibility = false;
    },

    getTodayDate() {
      const d = new Date();
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    initNotificationDateRange() {
      const today = this.getTodayDate();
      this.notificationFilters.dtFrom = today;
      this.notificationFilters.dtTo = today;
      this.rangeDate = `${today} to ${today}`;
    },

    initSentBoxDateRange() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const monthStr = String(month + 1).padStart(2, "0");
      const lastDay = new Date(year, month + 1, 0).getDate();
      const dtFrom = `${year}-${monthStr}-01`;
      const dtTo = `${year}-${monthStr}-${String(lastDay).padStart(2, "0")}`;
      this.sentBoxFilters.dtFrom = dtFrom;
      this.sentBoxFilters.dtTo = dtTo;
      this.sentBoxDateRange = `${dtFrom} to ${dtTo}`;
    },

    initChallanDateRange() {
      const today = this.getTodayDate();
      this.challanFilters.dtFrom = today;
      this.challanFilters.dtTo = today;
      this.challanDateRange = `${today} to ${today}`;
    },

    formatNumber(value) {
      const num = Number(value || 0);
      return Number.isFinite(num) ? num.toLocaleString() : "0";
    },

    formatMetaTitle(value) {
      if (!value) return "-";
      return String(value).replace(/_/g, " ");
    },

    formatIsSeen(value) {
      if (value === true) return "Seen";
      if (value === false) return "Not seen";
      return "-";
    },

    getRoleLabel(value) {
      const match = this.roleOptions.find((item) => item.value === value);
      if (match) return match.label;
      if (!value) return "-";
      return value.charAt(0).toUpperCase() + value.slice(1);
    },

    formatNotificationDate(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "-";
      return date.toLocaleString("en-UK", {
        year: "numeric",
        day: "numeric",
        month: "short",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    },

    mapMetaTitleOptions(items) {
      return (items || []).map((item) => ({
        label: this.formatMetaTitle(item),
        value: item,
      }));
    },

    async onStatusChange() {
      this.clearMoveToQueueSelection();
      this.loadRequestId += 1;
      this.currentPage = 1;
      this.isDetails = false;
      this.items = [];
      this.challanStatus = "pending";
      this.challanFilteredTotal = 0;
      this.clearChallanCache();
      this.challanPostgresStatsReady = false;
      this.sentBoxStatus = "dbPending";
      this.sentBoxFilteredTotal = 0;
      this.clearSentBoxCache();
      this.sentBoxStatsReady = false;
      if (this.currentStatus === "challan") {
        this.initChallanDateRange();
      } else {
        this.challanDateRange = "";
        this.challanFilters.dtFrom = "";
        this.challanFilters.dtTo = "";
      }
      if (this.currentStatus === "sent") {
        this.searchQuery = "";
        this.initSentBoxDateRange();
      }
      await this.$nextTick();
      await this.reloadCurrentView();
    },

    async reloadCurrentView() {
      if (this.isNotificationView) {
        this.initNotificationDateRange();
        await this.ensureNotificationFilters();
        await this.loadNotificationDashboard();
      } else {
        await this.LoadData();
      }
    },

    async ensureNotificationFilters() {
      if (this.notificationFiltersLoaded) return;
      await Promise.all([this.loadMetaTitles(), this.loadRoles()]);
      this.notificationFiltersLoaded = true;
    },

    async loadMetaTitles() {
      const res = await this.get({
        url:
          this.$store.state.domain +
          "Chat/NotificationMetaTitles?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      });
      this.metaTitleOptions = this.mapMetaTitleOptions(res);
    },

    async loadRoles() {
      const res = await this.get({
        url:
          this.$store.state.domain +
          "Chat/NotificationRoles?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      });
      this.roleOptions = Array.isArray(res) ? res : [];
    },

    buildNotificationDashboardUrl() {
      const params = new URLSearchParams({
        db: this.$store.state.userData.db,
        cID: String(this.$store.state.userData.cId),
        page: String(this.currentPage),
        pageSize: String(this.notificationPageSize),
      });

      if (this.searchQuery.trim()) {
        params.set("search", this.searchQuery.trim());
      }
      if (this.notificationFilters.metaTitle) {
        params.set("metaTitle", this.notificationFilters.metaTitle);
      }
      if (this.notificationFilters.role) {
        params.set("role", this.notificationFilters.role);
      }
      if (this.notificationFilters.isSeen === true || this.notificationFilters.isSeen === false) {
        params.set("isSeen", String(this.notificationFilters.isSeen));
      }
      if (this.notificationFilters.dtFrom) {
        params.set("dtFrom", this.notificationFilters.dtFrom);
      }
      if (this.notificationFilters.dtTo) {
        params.set("dtTo", this.notificationFilters.dtTo);
      }

      return (
        this.$store.state.domain +
        "Chat/NotificationDashboard?" +
        params.toString()
      );
    },

    async loadNotificationDashboard() {
      if (!this.isNotificationView) return;

      const requestId = ++this.loadRequestId;
      this.dataLoading = true;
      this.isDetails = false;

      try {
        const res = await this.get({
          url: this.buildNotificationDashboardUrl(),
          token: this.$store.state.userData.token,
          dashboard: true,
        });

        if (requestId !== this.loadRequestId) return;

        if (res && res.status === "success") {
          const filteredTotal =
            res.filteredTotal ?? res.summary?.total ?? (res.data?.length || 0);
          const maxPage = Math.max(
            1,
            Math.ceil(filteredTotal / this.notificationPageSize) || 1
          );
          if (this.currentPage > maxPage) {
            this.currentPage = maxPage;
            await this.loadNotificationDashboard();
            return;
          }

          this.items = Array.isArray(res.data) ? res.data : [];
          this.notificationSummary = {
            total: res.summary?.total || 0,
            seen: res.summary?.seen || 0,
            notSeen: res.summary?.notSeen || 0,
          };
          this.notificationFilteredTotal = filteredTotal;
          this.notificationTotalPages = res.totalPages || 1;
          if (res.metaTitles?.length && !this.metaTitleOptions.length) {
            this.metaTitleOptions = this.mapMetaTitleOptions(res.metaTitles);
          }
        } else {
          this.items = [];
          this.notificationSummary = { total: 0, seen: 0, notSeen: 0 };
          this.notificationFilteredTotal = 0;
          this.notificationTotalPages = 1;
        }
      } finally {
        if (requestId === this.loadRequestId) {
          this.dataLoading = false;
        }
      }
    },

    onNotificationFilterChange() {
      this.currentPage = 1;
      this.loadNotificationDashboard();
    },

    onNotificationSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.loadNotificationDashboard();
      }, 400);
    },

    onNotificationPageSizeChange() {
      this.currentPage = 1;
      this.loadNotificationDashboard();
    },

    onNotificationPageChange(page) {
      this.currentPage = page;
      this.loadNotificationDashboard();
    },

    onLegacyPageSizeChange(size) {
      const nextSize = Math.min(Number(size ?? this.perPage) || 20, 200);
      this.perPage = nextSize;
      this.currentPage = 1;
      if (this.isChallanView) {
        this.clearChallanCache();
        this.challanPostgresStatsReady = false;
        this.prefetchAllChallanStatuses({
          status: this.challanStatus || "pending",
          pageSize: nextSize,
          force: true,
        });
      } else if (this.isSentBoxView) {
        this.clearSentBoxCache();
        this.sentBoxStatsReady = false;
        this.prefetchAllSentBoxStatuses({
          status: this.sentBoxStatus || "dbPending",
          pageSize: nextSize,
          force: true,
        });
      }
    },

    onLegacyPageChange(page) {
      const nextPage = Math.max(1, Number(page) || 1);
      this.currentPage = nextPage;
      if (this.isChallanView) {
        this.loadChallanData({
          page: nextPage,
          pageSize: this.getChallanPageSize(this.perPage),
        });
      } else if (this.isSentBoxView) {
        this.loadSentBoxData({
          page: nextPage,
          pageSize: this.getSentBoxPageSize(this.perPage),
        });
      }
    },

    onLegacySearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        if (!this.isLegacyServerPaged) return;
        this.currentPage = 1;
        if (this.isChallanView) {
          this.clearChallanCache();
          this.challanPostgresStatsReady = false;
          this.prefetchAllChallanStatuses({
            status: this.challanStatus || "pending",
            force: true,
          });
        } else if (this.isSentBoxView) {
          this.loadSentBoxData({ page: 1, force: true });
        }
      }, 400);
    },

    clearLegacySearch() {
      this.searchQuery = "";
      if (!this.isLegacyServerPaged) return;
      this.currentPage = 1;
      if (this.isChallanView) {
        this.clearChallanCache();
        this.challanPostgresStatsReady = false;
        this.prefetchAllChallanStatuses({
          status: this.challanStatus || "pending",
          force: true,
        });
      } else if (this.isSentBoxView) {
        this.loadSentBoxData({ page: 1, force: true });
      }
    },

    onSentBoxDateRangeChange(selectedDates, dateStr) {
      if (dateStr) {
        const parts = dateStr.split(" to ");
        if (parts.length === 1) {
          this.sentBoxFilters.dtFrom = parts[0];
          this.sentBoxFilters.dtTo = parts[0];
        } else {
          this.sentBoxFilters.dtFrom = parts[0];
          this.sentBoxFilters.dtTo = parts[1];
        }
      } else {
        this.sentBoxFilters.dtFrom = "";
        this.sentBoxFilters.dtTo = "";
      }
      this.currentPage = 1;
      this.clearSentBoxCache();
      this.sentBoxStatsReady = false;
      this.prefetchAllSentBoxStatuses({
        status: this.sentBoxStatus || "dbPending",
        force: true,
      });
    },

    clearSentBoxDateRange() {
      this.sentBoxDateRange = "";
      this.sentBoxFilters.dtFrom = "";
      this.sentBoxFilters.dtTo = "";
      this.currentPage = 1;
      this.clearSentBoxCache();
      this.sentBoxStatsReady = false;
      this.prefetchAllSentBoxStatuses({
        status: this.sentBoxStatus || "dbPending",
        force: true,
      });
    },

    isSentBoxCardLoading() {
      return this.sentBoxStatsLoading && !this.sentBoxStatsReady;
    },

    mapSentBoxApiStatus(status) {
      const s = status || this.sentBoxStatus || "dbPending";
      if (s === "error") return "failed";
      if (s === "dbPending") return "dbPending";
      return s;
    },

    getSentBoxPageSize(pageSize) {
      const raw = pageSize != null ? pageSize : this.perPage;
      return Math.min(Math.max(1, Number(raw) || 20), 50);
    },

    getSentBoxFilteredTotalForStatus(status) {
      const s = status || this.sentBoxStatus || "dbPending";
      if (s === "pending") {
        return Number(this.sentSummaryObj.processing) || 0;
      }
      if (s === "dbPending") {
        return Number(this.sentSummaryObj.dbPending) || 0;
      }
      if (s === "sent") return Number(this.sentSummaryObj.sent) || 0;
      if (s === "error") return Number(this.sentSummaryObj.failed) || 0;
      return Number(this.sentSummaryObj.total) || 0;
    },

    getSentBoxCacheScope() {
      return [
        this.sentBoxFilters.dtFrom || "",
        this.sentBoxFilters.dtTo || "",
        String(this.searchQuery || "").trim(),
      ].join("|");
    },

    getSentBoxCacheKey(status, page, pageSize) {
      return [
        this.getSentBoxCacheScope(),
        status || "dbPending",
        String(page || 1),
        String(pageSize || 20),
      ].join("::");
    },

    clearSentBoxCache() {
      this.sentBoxCache = {};
      this.sentBoxPrefetchId += 1;
    },

    getSentBoxCacheEntry(status, page, pageSize) {
      return (
        this.sentBoxCache[this.getSentBoxCacheKey(status, page, pageSize)] ||
        null
      );
    },

    setSentBoxCacheEntry(status, page, pageSize, entry) {
      this.$set(
        this.sentBoxCache,
        this.getSentBoxCacheKey(status, page, pageSize),
        entry
      );
    },

    applySentBoxCacheEntry(cached) {
      this.items = Array.isArray(cached.items) ? cached.items.slice() : [];
      this.sentBoxFilteredTotal =
        Number(cached.filteredTotal) ||
        this.getSentBoxFilteredTotalForStatus(this.sentBoxStatus);
      this.currentPage = Number(cached.page) || 1;
      this.dataLoading = false;
    },

    buildSentBoxStatsQueryParams() {
      const params = new URLSearchParams({
        db: this.$store.state.userData.db,
        cID: String(this.$store.state.userData.cId),
      });
      if (this.sentBoxFilters.dtFrom) {
        params.set("dtFrom", this.sentBoxFilters.dtFrom);
      }
      if (this.sentBoxFilters.dtTo) {
        params.set("dtTo", this.sentBoxFilters.dtTo);
      }
      return params;
    },

    buildSentBoxDetailsQueryParams({ status, page, pageSize } = {}) {
      const resolvedPage = Math.max(
        1,
        Number(page != null ? page : this.currentPage) || 1
      );
      const resolvedPageSize = this.getSentBoxPageSize(pageSize);
      const uiStatus = status || this.sentBoxStatus || "dbPending";

      const params = new URLSearchParams({
        db: this.$store.state.userData.db,
        cID: String(this.$store.state.userData.cId),
        status: this.mapSentBoxApiStatus(uiStatus),
        page: String(resolvedPage),
        pageSize: String(resolvedPageSize),
      });

      if (this.sentBoxFilters.dtFrom) {
        params.set("dtFrom", this.sentBoxFilters.dtFrom);
      }
      if (this.sentBoxFilters.dtTo) {
        params.set("dtTo", this.sentBoxFilters.dtTo);
      }

      return params;
    },

    buildLoadChatStatsUrl() {
      return (
        this.$store.state.domain +
        "Chat/LoadChatStats?" +
        this.buildSentBoxStatsQueryParams().toString()
      );
    },

    buildLoadChatDetailsUrl(overrides = {}) {
      return (
        this.$store.state.domain +
        "Chat/LoadChatDetails?" +
        this.buildSentBoxDetailsQueryParams(overrides).toString()
      );
    },

    parseChatStatsSummary(res = {}) {
      return {
        processing: Number(res.pendingCount) || 0,
        dbPending: Number(res.dbPending) || 0,
        sent: Number(res.sentCount) || 0,
        failed: Number(res.failedCount) || 0,
        total: Number(res.totalCount) || 0,
      };
    },

    normalizeChatStatsResponse(res) {
      if (res == null) return null;
      if (Array.isArray(res)) return null;
      if (typeof res !== "object") return null;
      if (res.status && String(res.status).toLowerCase() === "error") {
        return null;
      }
      if (
        res.dbPending != null ||
        res.pendingCount != null ||
        res.sentCount != null ||
        res.failedCount != null ||
        res.totalCount != null
      ) {
        return res;
      }
      return null;
    },

    normalizeChatDetailsResponse(res) {
      if (res == null) return null;
      if (Array.isArray(res)) return null;
      if (typeof res !== "object") return null;
      if (res.status && String(res.status).toLowerCase() === "error") {
        return null;
      }
      if (Array.isArray(res.data)) return res;
      return null;
    },

    async fetchChatStats() {
      const raw = await this.get({
        url: this.buildLoadChatStatsUrl(),
        token: this.$store.state.userData.token,
        dashboard: true,
      });
      const res = this.normalizeChatStatsResponse(raw);
      if (!res) return null;
      return this.parseChatStatsSummary(res);
    },

    isLatestSentBoxRequest(requestId) {
      return requestId === this.loadRequestId;
    },

    async fetchChatPage({ status, page, pageSize }) {
      const resolvedPageSize = this.getSentBoxPageSize(pageSize);
      const uiStatus = status || this.sentBoxStatus || "dbPending";
      const resolvedPage = Math.max(1, Number(page) || 1);

      const raw = await this.get({
        url: this.buildLoadChatDetailsUrl({
          status: uiStatus,
          page: resolvedPage,
          pageSize: resolvedPageSize,
        }),
        token: this.$store.state.userData.token,
        dashboard: true,
      });
      const res = this.normalizeChatDetailsResponse(raw);
      if (!res) return null;

      return {
        items: Array.isArray(res.data) ? res.data : [],
        page: resolvedPage,
      };
    },

    finalizeSentBoxCacheEntry(status, page, pageSize, partialEntry) {
      if (!partialEntry) return null;
      const filteredTotal = this.getSentBoxFilteredTotalForStatus(status);
      const size = this.getSentBoxPageSize(pageSize);
      const maxPage = Math.max(1, Math.ceil(filteredTotal / size) || 1);
      let resolvedPage = Math.max(1, Number(partialEntry.page) || 1);
      if (resolvedPage > maxPage) {
        resolvedPage = maxPage;
      }
      return {
        items: partialEntry.items || [],
        page: resolvedPage,
        filteredTotal,
      };
    },

    applySentBoxStatsSummary(summary) {
      if (!summary) return;
      this.sentSummaryObj = { ...this.sentSummaryObj, ...summary };
      this.sentBoxStatsReady = true;
    },

    async prefetchAllSentBoxStatuses(options = {}) {
      const pageSize = this.getSentBoxPageSize(
        options.pageSize != null ? options.pageSize : this.perPage
      );
      const activeStatus = options.status || this.sentBoxStatus || "dbPending";
      const statuses = this.sentBoxStatusTabs || [
        "dbPending",
        "pending",
        "sent",
        "error",
      ];
      const prefetchId = ++this.sentBoxPrefetchId;

      this.loadRequestId += 1;
      this.sentBoxStatus = activeStatus;
      this.currentPage = 1;
      this.isDetails = false;
      this.dataLoading = true;
      this.sentBoxStatsLoading = true;

      if (Number(this.perPage) !== pageSize) {
        this.perPage = pageSize;
      }

      const detailPromises = statuses.map(async (status) => {
        if (!options.force) {
          const existing = this.getSentBoxCacheEntry(status, 1, pageSize);
          if (existing) return { status, entry: existing, fromCache: true };
        }
        try {
          const partial = await this.fetchChatPage({
            status,
            page: 1,
            pageSize,
          });
          return { status, partial, fromCache: false };
        } catch (e) {
          return { status, partial: null, fromCache: false };
        }
      });

      const [statsSummary, ...detailResults] = await Promise.all([
        this.fetchChatStats(),
        ...detailPromises,
      ]);

      if (prefetchId !== this.sentBoxPrefetchId) return;

      this.applySentBoxStatsSummary(statsSummary);
      this.sentBoxStatsLoading = false;

      detailResults.forEach(({ status, entry, partial, fromCache }) => {
        if (fromCache && entry) {
          entry.filteredTotal = this.getSentBoxFilteredTotalForStatus(status);
          this.setSentBoxCacheEntry(status, 1, pageSize, entry);
          return;
        }
        const finalized = this.finalizeSentBoxCacheEntry(
          status,
          1,
          pageSize,
          partial
        );
        if (!finalized) return;
        this.setSentBoxCacheEntry(status, 1, pageSize, finalized);
      });

      const active = this.getSentBoxCacheEntry(activeStatus, 1, pageSize);
      if (active) {
        this.applySentBoxCacheEntry(active);
      } else {
        this.items = [];
        this.sentBoxFilteredTotal =
          this.getSentBoxFilteredTotalForStatus(activeStatus);
        this.dataLoading = false;
      }
    },

    prefetchMissingSentBoxTabs(pageSize) {
      const size = this.getSentBoxPageSize(pageSize);
      const statuses = this.sentBoxStatusTabs || [
        "dbPending",
        "pending",
        "sent",
        "error",
      ];
      const missing = statuses.filter(
        (status) => !this.getSentBoxCacheEntry(status, 1, size)
      );
      if (!missing.length) return;

      const prefetchId = this.sentBoxPrefetchId;
      missing.forEach(async (status) => {
        try {
          const partial = await this.fetchChatPage({
            status,
            page: 1,
            pageSize: size,
          });
          if (!partial || prefetchId !== this.sentBoxPrefetchId) return;
          const entry = this.finalizeSentBoxCacheEntry(
            status,
            1,
            size,
            partial
          );
          if (entry) this.setSentBoxCacheEntry(status, 1, size, entry);
        } catch (e) {
          // ignore
        }
      });
    },

    async loadSentBoxData(options = {}) {
      if (options.prefetchAll) {
        return this.prefetchAllSentBoxStatuses(options);
      }

      const status = options.status || this.sentBoxStatus || "dbPending";
      const pageSize = this.getSentBoxPageSize(
        options.pageSize != null ? options.pageSize : this.perPage
      );
      let page = Math.max(
        1,
        Number(options.page != null ? options.page : this.currentPage) || 1
      );

      if (!options.force) {
        const cached = this.getSentBoxCacheEntry(status, page, pageSize);
        if (cached) {
          this.sentBoxStatus = status;
          this.applySentBoxCacheEntry(cached);
          this.prefetchMissingSentBoxTabs(pageSize);
          return;
        }
      }

      const requestId = ++this.loadRequestId;
      this.dataLoading = true;
      this.isDetails = false;
      this.sentBoxStatus = status;
      this.currentPage = page;
      if (Number(this.perPage) !== pageSize) {
        this.perPage = pageSize;
      }
      this.sentBoxStatsLoading = true;

      try {
        const [statsSummary, partial] = await Promise.all([
          this.fetchChatStats(),
          this.fetchChatPage({ status, page, pageSize }),
        ]);

        if (!this.isLatestSentBoxRequest(requestId)) return;

        this.applySentBoxStatsSummary(statsSummary);

        let entry = this.finalizeSentBoxCacheEntry(
          status,
          page,
          pageSize,
          partial
        );
        if (
          entry &&
          partial &&
          entry.page !== partial.page &&
          entry.page !== page
        ) {
          const partialRetry = await this.fetchChatPage({
            status,
            page: entry.page,
            pageSize,
          });
          entry = this.finalizeSentBoxCacheEntry(
            status,
            entry.page,
            pageSize,
            partialRetry
          );
        }

        if (!entry) {
          this.items = [];
          this.sentBoxFilteredTotal =
            this.getSentBoxFilteredTotalForStatus(status);
          return;
        }

        page = entry.page;
        this.currentPage = page;
        this.items = entry.items;
        this.sentBoxFilteredTotal = entry.filteredTotal;
        this.setSentBoxCacheEntry(status, page, pageSize, entry);
        this.prefetchMissingSentBoxTabs(pageSize);
      } catch (error) {
        if (!this.isLatestSentBoxRequest(requestId)) return;
        this.items = [];
        this.sentBoxFilteredTotal = 0;
      } finally {
        if (this.isLatestSentBoxRequest(requestId)) {
          this.dataLoading = false;
        }
        this.sentBoxStatsLoading = false;
      }
    },

    setSentBoxStatusFilter(value) {
      const next = value || "dbPending";
      if (next === this.sentBoxStatus && this.items.length) return;

      this.clearMoveToQueueSelection();
      this.sentBoxStatus = next;
      this.currentPage = 1;
      this.isDetails = false;

      const pageSize = this.getSentBoxPageSize(this.perPage);
      const cached = this.getSentBoxCacheEntry(next, 1, pageSize);
      if (cached) {
        this.applySentBoxCacheEntry(cached);
        return;
      }

      this.loadSentBoxData({ page: 1, status: next });
    },

    onSentBoxStatusFilterChange() {
      this.currentPage = 1;
      this.isDetails = false;
      const pageSize = this.getSentBoxPageSize(this.perPage);
      const status = this.sentBoxStatus || "dbPending";
      const cached = this.getSentBoxCacheEntry(status, 1, pageSize);
      if (cached) {
        this.applySentBoxCacheEntry(cached);
        return;
      }
      this.loadSentBoxData({ page: 1 });
    },

    setChallanStatusFilter(value) {
      const next = value || "pending";
      // Same card already active — keep current page data, no refetch
      if (next === this.challanStatus && this.items.length) return;

      this.clearMoveToQueueSelection();
      this.challanStatus = next;
      this.currentPage = 1;
      this.isDetails = false;

      const pageSize = this.getChallanPageSize(this.perPage);
      const cached = this.getChallanCacheEntry(next, 1, pageSize);
      if (cached) {
        // Instant switch — page 1 was prefetched
        this.applyChallanCacheEntry(cached);
        return;
      }

      this.loadChallanData({ page: 1, status: next });
    },

    onChallanStatusFilterChange() {
      this.currentPage = 1;
      this.isDetails = false;
      const pageSize = this.getChallanPageSize(this.perPage);
      const status = this.challanStatus || "pending";
      const cached = this.getChallanCacheEntry(status, 1, pageSize);
      if (cached) {
        this.applyChallanCacheEntry(cached);
        return;
      }
      this.loadChallanData({ page: 1 });
    },

    onChallanDateRangeChange(selectedDates, dateStr) {
      if (dateStr) {
        const parts = dateStr.split(" to ");
        if (parts.length === 1) {
          this.challanFilters.dtFrom = parts[0];
          this.challanFilters.dtTo = parts[0];
        } else {
          this.challanFilters.dtFrom = parts[0];
          this.challanFilters.dtTo = parts[1];
        }
      } else {
        this.challanFilters.dtFrom = "";
        this.challanFilters.dtTo = "";
      }
      this.currentPage = 1;
      this.clearChallanCache();
      this.challanPostgresStatsReady = false;
      this.prefetchAllChallanStatuses({
        status: this.challanStatus || "pending",
        force: true,
      });
    },

    clearChallanDateRange() {
      this.challanDateRange = "";
      this.challanFilters.dtFrom = "";
      this.challanFilters.dtTo = "";
      this.currentPage = 1;
      this.clearChallanCache();
      this.challanPostgresStatsReady = false;
      this.prefetchAllChallanStatuses({
        status: this.challanStatus || "pending",
        force: true,
      });
    },

    isChallanCardLoading() {
      return (
        this.challanPostgresStatsLoading && !this.challanPostgresStatsReady
      );
    },

    mapChallanApiStatus(status) {
      const s = status || this.challanStatus || "pending";
      if (s === "error") return "failed";
      return s;
    },

    getChallanPageSize(pageSize) {
      const raw =
        pageSize != null ? pageSize : this.perPage;
      return Math.min(Math.max(1, Number(raw) || 20), 50);
    },

    getChallanFilteredTotalForStatus(status) {
      const s = status || this.challanStatus || "pending";
      if (s === "pending") return Number(this.summaryObj.pending) || 0;
      if (s === "sent") return Number(this.summaryObj.sent) || 0;
      if (s === "error") return Number(this.summaryObj.error) || 0;
      if (s === "not-processing") {
        return Number(this.summaryObj.notProcessing) || 0;
      }
      return Number(this.summaryObj.total) || 0;
    },

    getChallanCacheScope() {
      return [
        this.challanFilters.dtFrom || "",
        this.challanFilters.dtTo || "",
        String(this.searchQuery || "").trim(),
      ].join("|");
    },

    getChallanCacheKey(status, page, pageSize) {
      return [
        this.getChallanCacheScope(),
        status || "pending",
        String(page || 1),
        String(pageSize || 20),
      ].join("::");
    },

    clearChallanCache() {
      this.challanCache = {};
      this.challanPrefetchId += 1;
    },

    getChallanCacheEntry(status, page, pageSize) {
      return this.challanCache[this.getChallanCacheKey(status, page, pageSize)] || null;
    },

    setChallanCacheEntry(status, page, pageSize, entry) {
      this.$set(
        this.challanCache,
        this.getChallanCacheKey(status, page, pageSize),
        entry
      );
    },

    applyChallanCacheEntry(cached) {
      this.items = Array.isArray(cached.items) ? cached.items.slice() : [];
      this.challanFilteredTotal =
        Number(cached.filteredTotal) ||
        this.getChallanFilteredTotalForStatus(this.challanStatus);
      this.currentPage = Number(cached.page) || 1;
      this.dataLoading = false;
    },

    buildChallanStatsQueryParams() {
      const params = new URLSearchParams({
        db: this.$store.state.userData.db,
        cID: String(this.$store.state.userData.cId),
      });
      if (this.challanFilters.dtFrom) {
        params.set("dtFrom", this.challanFilters.dtFrom);
      }
      if (this.challanFilters.dtTo) {
        params.set("dtTo", this.challanFilters.dtTo);
      }
      return params;
    },

    buildChallanDetailsQueryParams({ status, page, pageSize } = {}) {
      const resolvedPage = Math.max(
        1,
        Number(page != null ? page : this.currentPage) || 1
      );
      const resolvedPageSize = this.getChallanPageSize(pageSize);
      const uiStatus = status || this.challanStatus || "pending";

      const params = new URLSearchParams({
        db: this.$store.state.userData.db,
        cID: String(this.$store.state.userData.cId),
        status: this.mapChallanApiStatus(uiStatus),
        page: String(resolvedPage),
        pageSize: String(resolvedPageSize),
      });

      if (this.challanFilters.dtFrom) {
        params.set("dtFrom", this.challanFilters.dtFrom);
      }
      if (this.challanFilters.dtTo) {
        params.set("dtTo", this.challanFilters.dtTo);
      }

      return params;
    },

    buildLoadChallanStatsUrl() {
      return (
        this.$store.state.domain +
        "Chat/LoadChallanStats?" +
        this.buildChallanStatsQueryParams().toString()
      );
    },

    buildLoadChallanDetailsUrl(overrides = {}) {
      return (
        this.$store.state.domain +
        "Chat/LoadChallanDetails?" +
        this.buildChallanDetailsQueryParams(overrides).toString()
      );
    },

    parseChallanStatsSummary(res = {}) {
      return {
        pending: Number(res.pendingCount) || 0,
        sent: Number(res.sentCount) || 0,
        error: Number(res.failedCount) || 0,
        notProcessing: Number(res.notProcessingCount) || 0,
        total: Number(res.totalCount) || 0,
      };
    },

    normalizeChallanStatsResponse(res) {
      if (res == null) return null;
      if (Array.isArray(res)) return null;
      if (typeof res !== "object") return null;
      if (res.status && String(res.status).toLowerCase() === "error") {
        return null;
      }
      if (
        res.pendingCount != null ||
        res.sentCount != null ||
        res.failedCount != null ||
        res.notProcessingCount != null ||
        res.totalCount != null
      ) {
        return res;
      }
      return null;
    },

    normalizeChallanDetailsResponse(res) {
      if (res == null) return null;
      if (Array.isArray(res)) return null;
      if (typeof res !== "object") return null;
      if (res.status && String(res.status).toLowerCase() === "error") {
        return null;
      }
      if (Array.isArray(res.data)) return res;
      return null;
    },

    async fetchChallanStats() {
      const raw = await this.get({
        url: this.buildLoadChallanStatsUrl(),
        token: this.$store.state.userData.token,
        dashboard: true,
      });
      const res = this.normalizeChallanStatsResponse(raw);
      if (!res) return null;
      return this.parseChallanStatsSummary(res);
    },

    isLatestChallanRequest(requestId) {
      return requestId === this.loadRequestId;
    },

    /** LoadChallanDetails — rows only; KPI counts come from LoadChallanStats. */
    async fetchChallanPage({ status, page, pageSize }) {
      const resolvedPageSize = this.getChallanPageSize(pageSize);
      const uiStatus = status || this.challanStatus || "pending";
      let resolvedPage = Math.max(1, Number(page) || 1);

      const raw = await this.get({
        url: this.buildLoadChallanDetailsUrl({
          status: uiStatus,
          page: resolvedPage,
          pageSize: resolvedPageSize,
        }),
        token: this.$store.state.userData.token,
        dashboard: true,
      });
      const res = this.normalizeChallanDetailsResponse(raw);
      if (!res) return null;

      return {
        items: Array.isArray(res.data) ? res.data : [],
        page: resolvedPage,
      };
    },

    finalizeChallanCacheEntry(status, page, pageSize, partialEntry) {
      if (!partialEntry) return null;
      const filteredTotal = this.getChallanFilteredTotalForStatus(status);
      const size = this.getChallanPageSize(pageSize);
      const maxPage = Math.max(1, Math.ceil(filteredTotal / size) || 1);
      let resolvedPage = Math.max(1, Number(partialEntry.page) || 1);
      if (resolvedPage > maxPage) {
        resolvedPage = maxPage;
      }
      return {
        items: partialEntry.items || [],
        page: resolvedPage,
        filteredTotal,
      };
    },

    applyChallanStatsSummary(summary) {
      if (!summary) return;
      this.summaryObj = { ...this.summaryObj, ...summary };
      this.challanPostgresStatsReady = true;
    },

    /**
     * LoadChallanStats + all tab page-1 details in parallel.
     */
    async prefetchAllChallanStatuses(options = {}) {
      const pageSize = this.getChallanPageSize(
        options.pageSize != null ? options.pageSize : this.perPage
      );
      const activeStatus = options.status || this.challanStatus || "pending";
      const statuses = this.challanStatusTabs || [
        "not-processing",
        "pending",
        "sent",
        "error",
      ];
      const prefetchId = ++this.challanPrefetchId;

      this.loadRequestId += 1;
      this.challanStatus = activeStatus;
      this.currentPage = 1;
      this.isDetails = false;
      this.dataLoading = true;
      this.challanPostgresStatsLoading = true;

      if (Number(this.perPage) !== pageSize) {
        this.perPage = pageSize;
      }

      const detailPromises = statuses.map(async (status) => {
        if (!options.force) {
          const existing = this.getChallanCacheEntry(status, 1, pageSize);
          if (existing) return { status, entry: existing, fromCache: true };
        }
        try {
          const partial = await this.fetchChallanPage({
            status,
            page: 1,
            pageSize,
          });
          return { status, partial, fromCache: false };
        } catch (e) {
          return { status, partial: null, fromCache: false };
        }
      });

      const [statsSummary, ...detailResults] = await Promise.all([
        this.fetchChallanStats(),
        ...detailPromises,
      ]);

      if (prefetchId !== this.challanPrefetchId) return;

      this.applyChallanStatsSummary(statsSummary);
      this.challanPostgresStatsLoading = false;

      detailResults.forEach(({ status, entry, partial, fromCache }) => {
        if (fromCache && entry) {
          entry.filteredTotal = this.getChallanFilteredTotalForStatus(status);
          this.setChallanCacheEntry(status, 1, pageSize, entry);
          return;
        }
        const finalized = this.finalizeChallanCacheEntry(
          status,
          1,
          pageSize,
          partial
        );
        if (!finalized) return;
        this.setChallanCacheEntry(status, 1, pageSize, finalized);
      });

      const active = this.getChallanCacheEntry(activeStatus, 1, pageSize);
      if (active) {
        this.applyChallanCacheEntry(active);
      } else {
        this.items = [];
        this.challanFilteredTotal =
          this.getChallanFilteredTotalForStatus(activeStatus);
        this.dataLoading = false;
      }
    },

    prefetchMissingChallanTabs(pageSize) {
      const size = this.getChallanPageSize(pageSize);
      const statuses = this.challanStatusTabs || [
        "not-processing",
        "pending",
        "sent",
        "error",
      ];
      const missing = statuses.filter(
        (status) => !this.getChallanCacheEntry(status, 1, size)
      );
      if (!missing.length) return;

      const prefetchId = this.challanPrefetchId;
      missing.forEach(async (status) => {
        try {
          const partial = await this.fetchChallanPage({
            status,
            page: 1,
            pageSize: size,
          });
          if (!partial || prefetchId !== this.challanPrefetchId) return;
          const entry = this.finalizeChallanCacheEntry(
            status,
            1,
            size,
            partial
          );
          if (entry) this.setChallanCacheEntry(status, 1, size, entry);
        } catch (e) {
          // ignore
        }
      });
    },

    async loadChallanData(options = {}) {
      if (options.prefetchAll) {
        return this.prefetchAllChallanStatuses(options);
      }

      const status = options.status || this.challanStatus || "pending";
      const pageSize = this.getChallanPageSize(
        options.pageSize != null ? options.pageSize : this.perPage
      );
      let page = Math.max(
        1,
        Number(options.page != null ? options.page : this.currentPage) || 1
      );

      if (!options.force) {
        const cached = this.getChallanCacheEntry(status, page, pageSize);
        if (cached) {
          this.challanStatus = status;
          this.applyChallanCacheEntry(cached);
          this.prefetchMissingChallanTabs(pageSize);
          return;
        }
      }

      const requestId = ++this.loadRequestId;
      this.dataLoading = true;
      this.isDetails = false;
      this.challanStatus = status;
      this.currentPage = page;
      if (Number(this.perPage) !== pageSize) {
        this.perPage = pageSize;
      }
      this.challanPostgresStatsLoading = true;

      try {
        const [statsSummary, partial] = await Promise.all([
          this.fetchChallanStats(),
          this.fetchChallanPage({ status, page, pageSize }),
        ]);

        if (!this.isLatestChallanRequest(requestId)) return;

        this.applyChallanStatsSummary(statsSummary);

        let entry = this.finalizeChallanCacheEntry(
          status,
          page,
          pageSize,
          partial
        );
        if (
          entry &&
          partial &&
          entry.page !== partial.page &&
          entry.page !== page
        ) {
          const partialRetry = await this.fetchChallanPage({
            status,
            page: entry.page,
            pageSize,
          });
          entry = this.finalizeChallanCacheEntry(
            status,
            entry.page,
            pageSize,
            partialRetry
          );
        }

        if (!entry) {
          return;
        }

        page = entry.page;
        this.currentPage = page;
        this.items = entry.items;
        this.challanFilteredTotal = entry.filteredTotal;
        this.setChallanCacheEntry(status, page, pageSize, entry);
        this.prefetchMissingChallanTabs(pageSize);
      } catch (error) {
        if (!this.isLatestChallanRequest(requestId)) return;
      } finally {
        if (this.isLatestChallanRequest(requestId)) {
          this.dataLoading = false;
        }
        this.challanPostgresStatsLoading = false;
      }
    },

    onDateRangeChange(selectedDates, dateStr) {
      if (dateStr) {
        const parts = dateStr.split(" to ");
        if (parts.length === 1) {
          this.notificationFilters.dtFrom = parts[0];
          this.notificationFilters.dtTo = parts[0];
        } else {
          this.notificationFilters.dtFrom = parts[0];
          this.notificationFilters.dtTo = parts[1];
        }
      } else {
        this.notificationFilters.dtFrom = "";
        this.notificationFilters.dtTo = "";
      }
      this.currentPage = 1;
      this.loadNotificationDashboard();
    },

    setIsSeenFilter(value) {
      this.notificationFilters.isSeen =
        this.notificationFilters.isSeen === value ? null : value;
      this.currentPage = 1;
      this.loadNotificationDashboard();
    },

    clearSearch() {
      this.searchQuery = "";
      this.currentPage = 1;
      this.loadNotificationDashboard();
    },

    clearDateRange() {
      this.rangeDate = "";
      this.notificationFilters.dtFrom = "";
      this.notificationFilters.dtTo = "";
      this.currentPage = 1;
      this.loadNotificationDashboard();
    },

    async LoadData() {
      if (this.currentStatus === "challanNotification") {
        this.initNotificationDateRange();
        await this.ensureNotificationFilters();
        return this.loadNotificationDashboard();
      }

      if (this.currentStatus == "challan") {
        if (!this.challanFilters.dtFrom && !this.challanFilters.dtTo) {
          this.initChallanDateRange();
        }
        this.clearChallanCache();
        this.challanPostgresStatsReady = false;
        return this.prefetchAllChallanStatuses({
          status: this.challanStatus || "pending",
          pageSize: this.getChallanPageSize(this.perPage),
          force: true,
        });
      }

      if (this.isSentBoxView) {
        if (!this.sentBoxFilters.dtFrom && !this.sentBoxFilters.dtTo) {
          this.initSentBoxDateRange();
        }
        this.clearSentBoxCache();
        this.sentBoxStatsReady = false;
        return this.prefetchAllSentBoxStatuses({
          status: this.sentBoxStatus || "dbPending",
          pageSize: this.getSentBoxPageSize(this.perPage),
          force: true,
        });
      }

      let endpoint = "Chat/LoadOutBox";
      let params = "";
      if (this.currentStatus == "draft") endpoint = "Chat/LoadDrafts";
      else if (this.currentStatus == "queue") {
        endpoint = "Chat/LoadQueue";
        params = "&page=1&pageSize=200";
      }

      const requestId = ++this.loadRequestId;
      this.dataLoading = true;
      this.isDetails = false;

      try {
        var obj = {
          url:
            this.$store.state.domain +
            endpoint +
            "?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            params,
          token: this.$store.state.userData.token,
          dashboard: true,
        };
        let res = await this.get(obj);

        if (requestId !== this.loadRequestId) return;

        this.items = res.data || [];
        if (this.currentStatus == "queue") {
          this.queueCount = res.total;
        }
      } catch (error) {
        if (requestId !== this.loadRequestId) return;
        this.items = [];
      } finally {
        if (requestId === this.loadRequestId) {
          this.dataLoading = false;
        }
      }
    },

    async LoadDetails(val) {
      const requestId = ++this.loadRequestId;
      this.dataLoading = true;
      this.isDetails = true;

      try {
        var obj = {
          url:
            this.$store.state.domain +
            "Chat/LoadDetails?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&status=" +
            val,
          token: this.$store.state.userData.token,
        };
        const result = await this.get(obj);
        if (requestId !== this.loadRequestId) return;
        this.items = result;
      } finally {
        if (requestId === this.loadRequestId) {
          this.dataLoading = false;
        }
      }
    },

    async Add() {
      this.CheckTitle();
      this.CheckMessage();
      if (this.CheckTitle() == false || this.CheckMessage() == false) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.myObj.id == 0) {
          //Add
          this.request = true;
          // console.log("obj:", this.myObj);
          var status = await this.post({
            url:
              this.$store.state.domain +
              "MessageTemplate?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Template added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) this.LoadData();
          this.visibility = false;
        } else {
          //Edit
          this.request = true;
          // console.log("edit_obj:", this.myObj);
          var status = await this.put({
            url:
              this.$store.state.domain +
              "MessageTemplate/" +
              this.myObj.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Template updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) this.LoadData();
          this.visibility = false;
        }
      }
    },

    async Delete(item) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Chat/DeleteSelected?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            item.campusID +
            "&id=" +
            item.id,
          body: null,
          message: "Message removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        // console.log(status);
        if (status) {
          if (this.isNotificationView) {
            this.loadNotificationDashboard();
          } else if (this.isChallanView) {
            this.clearChallanCache();
            this.challanPostgresStatsReady = false;
            this.prefetchAllChallanStatuses({
              status: this.challanStatus || "pending",
              force: true,
            });
          } else if (this.isSentBoxView) {
            this.clearSentBoxCache();
            this.sentBoxStatsReady = false;
            this.prefetchAllSentBoxStatuses({
              status: this.sentBoxStatus || "dbPending",
              force: true,
            });
          } else {
            let ind = this.items.findIndex((el) => el.id == item.id);
            this.items.splice(ind, 1);
          }
        }
      }
    },

    async deleteAll() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: `Do You want to Clear ${
          this.currentStatus == "draft"
            ? "Draft"
            : this.currentStatus == "challan"
            ? "Challan"
            : this.currentStatus == "challanNotification"
            ? "Notification"
            : "Outbox"
        } Messages?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });
      if (result.isConfirmed) {
        this.deleting = true;

        let endpoint = "Chat/ClearOutBox";
        let msg = "Outbox cleared!";
        if (this.currentStatus == "draft") {
          endpoint = "Chat/ClearDrafts";
          msg = "Draft Cleared!";
        } else if (this.currentStatus == "challan") {
          endpoint = "Chat/ClearChallan";
          msg = "Challan Cleared!";
        } else if (this.currentStatus == "challanNotification") {
          endpoint = "Chat/ClearChallanNotification";
          msg = "Notification Cleared!";
        }
        // console.log(endpoint, msg);

        var status = await this.post({
          url:
            this.$store.state.domain +
            endpoint +
            "?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: "",
          message: msg,
          context: this,
          token: this.$store.state.userData.token,
        });
        this.deleting = false;
        if (status) this.LoadData();
      }
    },
    async sendDraft() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "Do You want start sending draft messages?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });
      if (result.isConfirmed) {
        this.deleting = true;

        var status = await this.get({
          url:
            this.$store.state.domain +
            "Chat/StartSendingDraft?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          message: "Messages are being processed",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.deleting = false;
        this.LoadData();
      }
    },
    clearMoveToQueueSelection() {
      this.moveToQueueSelectedIds = [];
    },
    isRowEligibleForMoveToQueue(item) {
      if (!this.canSelectForMoveToQueue || !item || !item.id) return false;
      const status = String(item.status || "").toLowerCase();
      if (status !== "pending") return false;
      return item.moveToQueue !== true && item.moveToQueue !== 1;
    },
    isQueueRowSelected(id) {
      return this.moveToQueueSelectedIds.includes(id);
    },
    toggleQueueRowSelection(item, checked) {
      if (!item || !item.id) return;
      const id = item.id;
      if (checked) {
        if (!this.moveToQueueSelectedIds.includes(id)) {
          this.moveToQueueSelectedIds = [...this.moveToQueueSelectedIds, id];
        }
      } else {
        this.moveToQueueSelectedIds = this.moveToQueueSelectedIds.filter(
          (x) => x !== id
        );
      }
    },
    toggleSelectAllQueueRowsOnPage(checked) {
      const eligible = this.eligibleMoveToQueueItemsOnPage;
      if (!eligible.length) return;
      if (checked) {
        const merged = new Set([
          ...this.moveToQueueSelectedIds,
          ...eligible.map((item) => item.id),
        ]);
        this.moveToQueueSelectedIds = [...merged];
      } else {
        const pageIds = new Set(eligible.map((item) => item.id));
        this.moveToQueueSelectedIds = this.moveToQueueSelectedIds.filter(
          (id) => !pageIds.has(id)
        );
      }
    },
    getSilentMoveToQueueStorageKey() {
      const db = this.$store.state.userData.db || "";
      const cID = this.$store.state.userData.cId || 0;
      return `outbox_silent_move_to_queue_at_${db}_${cID}`;
    },
    getLastSilentMoveToQueueAt() {
      let stored = 0;
      try {
        stored = Number(
          sessionStorage.getItem(this.getSilentMoveToQueueStorageKey()) || 0
        );
      } catch (e) {
        stored = 0;
      }
      return Math.max(Number(this.lastSilentMoveToQueueAt) || 0, stored || 0);
    },
    markSilentMoveToQueueNow() {
      const now = Date.now();
      this.lastSilentMoveToQueueAt = now;
      try {
        sessionStorage.setItem(
          this.getSilentMoveToQueueStorageKey(),
          String(now)
        );
      } catch (e) {
        // ignore storage errors
      }
    },
    canSilentMoveToQueueNow() {
      const lastAt = this.getLastSilentMoveToQueueAt();
      if (!lastAt) return true;
      return Date.now() - lastAt >= this.silentMoveToQueueCooldownMs;
    },
    getSilentMoveToQueuePendingCount() {
      if (this.isSentBoxView && this.sentBoxStatus === "dbPending") {
        return (
          Number(this.sentSummaryObj.dbPending) ||
          Number(this.sentBoxFilteredTotal) ||
          (this.items || []).length ||
          0
        );
      }
      if (
        this.currentStatus === "challan" &&
        this.challanStatus === "pending"
      ) {
        return (
          Number(this.challanFilteredTotal) ||
          (this.items || []).length ||
          0
        );
      }
      return 0;
    },
    async onOutboxRefresh() {
      await this.LoadData();
      // Messages Pending / Challan Pending only, count > 0, and 5-min cooldown
      const pendingCount = this.getSilentMoveToQueuePendingCount();
      if (
        pendingCount > 0 &&
        this.canSilentMoveToQueueNow()
      ) {
        this.silentMoveToQueue();
      }
    },
    /** Background MoveToQueue — no confirm, no toast, no button spinner */
    silentMoveToQueue() {
      if (!this.canSilentMoveToQueueNow()) return;
      if (this.getSilentMoveToQueuePendingCount() <= 0) return;

      // Lock immediately so spam-refresh cannot fire again within 5 mins
      this.markSilentMoveToQueueNow();

      const url =
        this.$store.state.domain +
        "Chat/MoveToQueue?db=" +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId;

      axios({
        method: "post",
        url,
        headers: {
          Authorization: "bearer " + this.$store.state.userData.token,
        },
      }).catch(() => {
        // Silent by design — refresh already completed
      });
    },
    async sendQueue(scope) {
      const isChallan =
        scope === "challan" ||
        (!scope && this.currentStatus === "challan");
      const selectedIds = (this.moveToQueueSelectedIds || []).filter(Boolean);
      const useSelected = selectedIds.length > 0;
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: useSelected
          ? `${this.$t("Move selected pending message(s) to the queue?")} (${selectedIds.length})`
          : isChallan
          ? this.$t(
              "Do you want to move pending challan messages to the queue?"
            )
          : this.$t("Do you want to move pending messages to the queue?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#7367f0",
        cancelButtonColor: "#82868b",
        confirmButtonText: this.$t("Yes, move to queue"),
        cancelButtonText: this.$t("Cancel"),
      });
      if (result.isConfirmed) {
        this.deleting = true;

        let status = false;
        if (useSelected) {
          status = await this.post({
            url:
              this.$store.state.domain +
              "Chat/MoveToQueueSelected?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: { ids: selectedIds },
            message: this.$t("Messages are being processed"),
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          status = await this.post({
            url:
              this.$store.state.domain +
              "Chat/MoveToQueue?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            message: this.$t("Messages are being processed"),
            context: this,
            token: this.$store.state.userData.token,
          });
        }
        this.deleting = false;
        if (status) {
          this.clearMoveToQueueSelection();
          this.LoadData();
        }
      }
    },
    async sendChallan() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "Do You want start sending challan messages?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });
      if (result.isConfirmed) {
        this.deleting = true;

        var status = await this.get({
          url:
            this.$store.state.domain +
            "Chat/StartSendingChallan?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          message: "Messages are being processed",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.deleting = false;
        this.LoadData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.outbox-page {
  --bg: #faf9ff;
  --text: #2d1b69;
  --muted: #8a86b7;
  --purple: #7c5dfa;
  --line: #e0d8ff;
  --green: #10b981;
  --orange: #f59e0b;
  --pink: #ec4899;

  position: relative;
  margin: -1rem -1rem 0;
  padding: 1rem 1rem 1.5rem;
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  color: var(--text);
  min-height: calc(100vh - 12rem);
  overflow: visible;
}

.outbox-loading-bar {
  position: sticky;
  top: 0;
  z-index: 3;
  height: 3px;
  margin: -1rem -1rem 1rem;
  background: linear-gradient(90deg, transparent, #7c5dfa, #cbb9ff, transparent);
  background-size: 200% 100%;
  animation: outboxLoadSlide 1.1s linear infinite;
}

@keyframes outboxLoadSlide {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.outbox-page.is-loading {
  .outbox-table-card {
    opacity: 0.98;
  }
}

.outbox-shell {
  max-width: 100%;
  overflow: visible;
}

.outbox-section-head {
  margin-bottom: 1rem;
}

.outbox-section-head-compact {
  margin-bottom: 0.85rem;
}

.outbox-section-label {
  margin: 0 0 0.2rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.72rem;
  color: var(--muted);
  font-weight: 700;
}

.outbox-section-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.outbox-section-title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 800;
  color: var(--text);
}

.outbox-filter-panel {
  position: relative;
  overflow: visible;
  margin-bottom: 1.15rem;
}

.outbox-kpi-section {
  position: relative;
}

.outbox-filter-status {
  position: relative;
  min-width: 11.5rem;
  width: 11.5rem;
  flex-shrink: 0;
}

.outbox-filter-bar-row {
  flex-wrap: nowrap;
  align-items: flex-end;
}

.outbox-filter-left {
  order: 1;
  flex: 1 1 auto;
  min-width: 0;
}

.outbox-filter-right-cluster {
  order: 2;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 0.65rem;
  margin-inline-start: auto;
  flex: 0 0 auto;
}

.outbox-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  border: 1.5px solid var(--line);
  background: #fff;
  color: var(--text);
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    border-color: #b8a9ff;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.outbox-icon-btn-danger {
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.25);
  background: rgba(239, 68, 68, 0.04);

  &:hover:not(:disabled) {
    border-color: #ef4444;
    background: rgba(239, 68, 68, 0.08);
  }
}

.notification-filter-fields {
  grid-template-columns:
    minmax(0, 1.05fr)
    minmax(0, 0.8fr)
    minmax(0, 0.8fr)
    minmax(0, 0.95fr);
}

.outbox-legacy-filter-fields {
  grid-template-columns: minmax(0, 1fr);
}

.outbox-legacy-filter-fields--challan {
  grid-template-columns:
    minmax(0, 1.2fr)
    minmax(0, 0.95fr)
    minmax(0, 1.1fr);
}

.demo-filter-bar.outbox-legacy-filter-bar--sent {
  flex-wrap: nowrap;
  gap: 0.65rem;
  align-items: flex-end;
}

.outbox-sent-filter-fields {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) 11.5rem;
  gap: 0.65rem;
  flex: 1 1 0;
  min-width: 0;
}

.outbox-sent-date-field {
  width: 100%;
  max-width: none;
  min-width: 0;
}

.outbox-legacy-filter-bar--sent .outbox-filter-right-cluster {
  flex: 0 0 auto;
  flex-shrink: 0;
  gap: 0.5rem;
}

.outbox-legacy-filter-bar--sent .outbox-filter-status {
  width: 11.5rem;
  min-width: 9.5rem;
}

.outbox-legacy-filter-bar--sent .outbox-refresh-btn {
  min-width: 7.5rem;
  padding-left: 0.85rem;
  padding-right: 0.85rem;
  white-space: nowrap;
  flex-shrink: 0;
}

.outbox-media-link {
  font-weight: 600;
  color: #7367f0;
}

.outbox-subtitle-text {
  color: #334155;
  font-weight: 600;
  font-size: 0.85rem;
}

.outbox-sent-filter-layout {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}

.outbox-sent-top-row {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: 0.75rem;
  align-items: end;
}

.outbox-sent-bottom-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr) auto;
  gap: 0.75rem;
  align-items: end;

  .outbox-sent-inline-refresh {
    min-height: 44px;
    white-space: nowrap;
  }
}

.outbox-legacy-actions {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex-shrink: 0;
}

.outbox-move-queue-btn {
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%) !important;
  color: #fff !important;
  border: none !important;

  &:hover:not(:disabled) {
    filter: brightness(1.05);
  }

  &:disabled {
    opacity: 0.65;
  }
}

.filter-input-wrap {
  position: relative;
}

.filter-clear-btn {
  position: absolute;
  top: 50%;
  right: 0.55rem;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: #8b83a7;
  padding: 0.15rem;
  line-height: 1;
  cursor: pointer;
  z-index: 2;

  &:hover {
    color: var(--purple);
  }
}

.outbox-search-group ::v-deep .input-group-text,
.outbox-search-group ::v-deep .form-control {
  min-height: 44px;
  border-color: #e0d8ff;
  color: var(--text);
}

.outbox-search-group ::v-deep .input-group-text {
  background: #fff;
  border-right: 0;
}

.outbox-search-group ::v-deep .form-control {
  border-left: 0;
  font-weight: 600;
  box-shadow: none;
}

.outbox-search-group ::v-deep .form-control:focus {
  border-color: #e0d8ff;
  box-shadow: none;
}

.outbox-search-input {
  padding-right: 2rem !important;
}

.outbox-date-input {
  min-height: 44px;
  border: 1.5px solid #e0d8ff;
  border-radius: 10px;
  padding-right: 2rem;
  color: var(--text);
  font-weight: 600;
  background: #fff;
}

.notification-kpi-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.outbox-challan-kpi-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.outbox-sentbox-kpi-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.outbox-refresh-btn {
  min-width: 130px;
}

.spin-icon {
  animation: notification-spin 0.8s linear infinite;
}

@keyframes notification-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.demo-card {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 16px;
  padding: 1.1rem 1.15rem 0.85rem;
  margin-bottom: 1rem;
  box-shadow: 0 10px 30px rgba(115, 103, 240, 0.08);
  overflow: visible;
}

.outbox-table-card {
  position: relative;
}

.demo-card-head {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.85rem;
  flex-wrap: wrap;

  h5 {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    color: var(--text);
  }
}

.demo-card-icon {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &.purple {
    background: rgba(124, 93, 250, 0.12);
    color: var(--purple);
  }
}

.outbox-pagination-top {
  margin-bottom: 0.85rem;
}

.pagination-controls-top {
  padding: 0.75rem 1rem;
  background: linear-gradient(180deg, #faf9ff 0%, #ffffff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.page-size-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .page-size-label {
    font-size: 0.8125rem;
    font-weight: 600;
    color: #64748b;
    margin: 0;
    white-space: nowrap;
  }
}

.page-size-select-compact {
  min-width: 75px;
  width: 75px;

  ::v-deep .vs__dropdown-toggle {
    height: 32px !important;
    min-height: 32px !important;
    border-radius: 6px !important;
    border: 1.5px solid #e0d8ff !important;
    padding: 0 0.5rem !important;
    background: #fff !important;
    font-size: 0.8125rem !important;
    display: flex !important;
    align-items: center !important;

    &:hover {
      border-color: #b8a9ff !important;
    }
  }

  ::v-deep .vs__selected-options {
    display: flex !important;
    align-items: center !important;
    padding: 0 !important;
  }

  ::v-deep .vs__selected {
    margin: 0 !important;
    padding: 0 !important;
    color: #2d1b69 !important;
    font-weight: 600 !important;
    font-size: 0.8125rem !important;
    line-height: 1 !important;
  }

  ::v-deep .vs__search {
    display: none !important;
  }

  ::v-deep .vs__actions {
    padding: 0 0 0 0.25rem !important;
  }

  ::v-deep .vs__clear,
  ::v-deep .vs__open-indicator {
    transform: scale(0.85);
  }
}

.pagination-count-display {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin: 0 0.5rem;
  min-width: 180px;

  .count-text {
    font-size: 0.8125rem;
    color: #64748b;
    font-weight: 500;
    white-space: nowrap;

    strong {
      color: #2d1b69;
      font-weight: 700;
    }
  }
}

.pagination-wrapper-compact {
  display: flex;
  align-items: center;

  ::v-deep .pagination {
    margin-bottom: 0;

    .page-link {
      padding: 0.375rem 0.625rem;
      font-size: 0.8125rem;
      line-height: 1.5;
      border-radius: 6px;
      margin: 0 0.125rem;
      border: 1px solid #e0d8ff;
      color: #64748b;
      font-weight: 500;
      min-width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;

      &:hover {
        background: #f3f0ff;
        border-color: #b8a9ff;
        color: #7c5dfa;
      }
    }

    .page-item.active .page-link {
      background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
      border-color: #7c5dfa;
      color: #fff;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(124, 93, 250, 0.3);
    }

    .page-item.disabled .page-link {
      background: #f8fafc;
      border-color: #e0d8ff;
      color: #cbd5e1;
      cursor: not-allowed;
    }
  }
}

.demo-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.demo-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 760px;

  th,
  td {
    padding: 0.85rem 0.65rem;
    border-bottom: 1px solid #f0edff;
    vertical-align: middle;
    font-size: 0.9rem;
    color: var(--text);
  }

  th {
    color: var(--muted);
    font-size: 0.74rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 700;
  }
}

.outbox-table ::v-deep {
  margin-bottom: 0;

  table {
    min-width: 760px;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #faf9ff;
    color: var(--muted) !important;
    font-size: 0.74rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 700 !important;
    border-bottom: 1px solid #f0edff !important;
    white-space: nowrap;
    vertical-align: middle;
    padding: 0.85rem 0.65rem;
  }

  tbody td {
    color: var(--text);
    border-top: none !important;
    border-bottom: 1px solid #f0edff !important;
    vertical-align: middle;
    padding: 0.75rem 0.65rem;
    font-size: 0.9rem;
  }

  tbody tr {
    transition: background 0.15s ease;

    &:hover {
      background: #f8f7ff;
    }
  }

  .b-table-empty-row td {
    border-bottom: none !important;
    padding: 0 !important;
  }
}

.notification-avatar {
  object-fit: cover;
}

.notification-name {
  font-weight: 700;
  color: var(--text);
}

.notification-message {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 420px;
  color: #4b5563;
  line-height: 1.45;
}

.outbox-date-text {
  display: inline-block;
  font-size: 0.82rem;
  font-weight: 600;
  color: #5b4f8a;
  white-space: nowrap;
}

.outbox-type-pill,
.outbox-role-pill,
.outbox-status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.22rem 0.6rem;
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: capitalize;
  white-space: nowrap;
}

.outbox-type-pill {
  background: rgba(59, 130, 246, 0.1);
  color: #2563eb;
}

.outbox-role-pill {
  background: rgba(124, 93, 250, 0.1);
  color: #6d4cdb;
}

.outbox-status-pill {
  &.is-seen {
    background: rgba(16, 185, 129, 0.12);
    color: #059669;
  }

  &.is-not-seen {
    background: rgba(245, 158, 11, 0.14);
    color: #d97706;
  }

  &.is-unknown {
    background: #f3f4f6;
    color: #6b7280;
  }
}

.outbox-empty-state {
  text-align: center;
  padding: 2.5rem 1rem 2rem;

  h4 {
    margin: 0.75rem 0 0.35rem;
    font-size: 1.05rem;
    font-weight: 800;
    color: var(--text);
  }

  p {
    margin: 0;
    color: var(--muted);
    font-size: 0.88rem;
  }
}

.outbox-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(124, 93, 250, 0.1);
  color: var(--purple);
}

.outbox-delete-btn {
  border-radius: 10px !important;
}

/* Skeleton */
@keyframes skelWave {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@keyframes skelFadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.skel-bone {
  display: inline-block;
  vertical-align: middle;
  background: linear-gradient(90deg, #eeeaf8 0%, #f7f5fc 40%, #eeeaf8 80%);
  background-size: 200% 100%;
  animation: skelWave 1.6s ease-in-out infinite;
  animation-delay: var(--skel-delay, 0s);
  border-radius: 6px;
}

.skel-kpi {
  background: #fff !important;
  border: 1px solid #ebe6f8 !important;
  box-shadow: 0 2px 10px rgba(115, 103, 240, 0.04) !important;
  min-height: 118px;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 1rem 1.1rem;
  animation: skelFadeIn 0.35s ease both;
  animation-delay: var(--skel-delay, 0s);

  .skel-kpi-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .skel-kpi-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
  }

  .skel-kpi-value {
    width: 48%;
    height: 26px;
    border-radius: 8px;
  }

  .skel-kpi-label {
    width: 68%;
    height: 12px;
  }
}

.skel-row {
  animation: skelFadeIn 0.35s ease both;
  animation-delay: var(--skel-delay, 0s);

  td {
    padding: 0.75rem 0.65rem;
    vertical-align: middle;
  }

  .skel-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
  }

  .skel-w-lg {
    width: 110px;
    height: 12px;
  }

  .skel-w-md {
    width: 88px;
    height: 12px;
  }

  .skel-w-xl {
    width: 180px;
    height: 12px;
  }

  .skel-w-sm {
    width: 42px;
    height: 12px;
  }

  .skel-pill {
    width: 48px;
    height: 22px;
    border-radius: 999px;
  }

  .skel-btn-sm {
    width: 34px;
    height: 34px;
    border-radius: 10px;
  }
}

.demo-filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-end;
  justify-content: space-between;
  padding: 0.9rem 1rem;
  background: #fff;
  border: 1px solid #e0d8ff;
  border-radius: 16px;
  box-shadow: 0 6px 18px rgba(115, 103, 240, 0.06);
  overflow: visible;
  position: relative;
}

.demo-filter-fields {
  display: grid;
  gap: 0.75rem;
  flex: 1;
  min-width: 0;
  overflow: visible;
}

.demo-filter-item {
  min-width: 0;
  position: relative;

  label {
    display: block;
    margin-bottom: 0.35rem;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--muted);
  }
}

.demo-select ::v-deep .vs__dropdown-toggle {
  background: #fff;
  border: 1.5px solid #e0d8ff;
  border-radius: 10px;
  min-height: 44px;
  color: var(--text);
  box-shadow: none;
}

.demo-select ::v-deep .vs__dropdown-toggle:hover {
  border-color: #b8a9ff;
}

.demo-select ::v-deep.vs--open .vs__dropdown-toggle {
  border-color: #7c5dfa;
  box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.15);
}

.demo-select ::v-deep .vs__search,
.demo-select ::v-deep .vs__selected {
  color: var(--text) !important;
  font-weight: 600;
}

.demo-select {
  position: relative;
}

.demo-select ::v-deep .vs__dropdown-menu {
  background: #fff !important;
  border: 1px solid #e0d8ff !important;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(45, 27, 105, 0.12);
  padding: 0.35rem;
}

.demo-select ::v-deep .vs__dropdown-option {
  color: #2d1b69 !important;
  border-radius: 8px;
  padding: 0.55rem 0.75rem;
  margin: 0.1rem 0;
  font-weight: 600;
}

.demo-select ::v-deep .vs__dropdown-option--highlight {
  background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%) !important;
  color: #ffffff !important;
}

.demo-excel-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  white-space: nowrap;
  border: 1.5px solid #e0d8ff;
  background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
  color: #fff;
  border-radius: 10px;
  padding: 0.7rem 1rem;
  font-weight: 700;
  min-height: 44px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(124, 93, 250, 0.25);

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #6d4cdb 0%, #8b6ff5 100%);
    border-color: #7c5dfa;
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(124, 93, 250, 0.35);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
}

.demo-kpi-grid {
  display: grid;
  gap: 0.95rem;
  margin-bottom: 1.35rem;
}

.demo-kpi-card {
  background: #fff;
  border: 1.5px solid #ebe7ff;
  border-radius: 16px;
  padding: 1.1rem 1.1rem 1rem;
  box-shadow: 0 6px 18px rgba(115, 103, 240, 0.08);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    border-color: #d4c7ff;
    box-shadow: 0 12px 28px rgba(115, 103, 240, 0.16);
  }

  &.is-clickable {
    cursor: pointer;
  }

  &.is-active {
    border-color: #7c5dfa;
    box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.15);
  }

  &.is-loading-stats {
    pointer-events: none;
    cursor: wait;
    animation: challanKpiPulse 1.1s ease-in-out infinite;

    &:hover {
      transform: none;
    }
  }
}

.demo-kpi-icon-spinner {
  width: 1rem !important;
  height: 1rem !important;
  color: inherit;
}

.demo-kpi-value-shimmer {
  display: inline-block;
  width: 3.25rem;
  height: 1.55rem;
  border-radius: 8px;
  vertical-align: middle;
  background: linear-gradient(90deg, #ebe6f8 0%, #f7f5fc 45%, #ebe6f8 90%);
  background-size: 200% 100%;
  animation: skelWave 1.2s ease-in-out infinite;
}

@keyframes challanKpiPulse {
  0%,
  100% {
    opacity: 1;
    box-shadow: 0 6px 18px rgba(115, 103, 240, 0.08);
  }
  50% {
    opacity: 0.72;
    box-shadow: 0 6px 18px rgba(115, 103, 240, 0.18);
  }
}

.demo-kpi-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.7rem;
}

.demo-kpi-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &.icon-purple {
    background: rgba(124, 93, 250, 0.12);
    color: var(--purple);
  }

  &.icon-green {
    background: rgba(16, 185, 129, 0.12);
    color: #059669;
  }

  &.icon-orange {
    background: rgba(245, 158, 11, 0.14);
    color: #d97706;
  }

  &.icon-blue {
    background: rgba(59, 130, 246, 0.14);
    color: #2563eb;
  }

  &.icon-pink {
    background: rgba(236, 72, 153, 0.12);
    color: var(--pink);
  }
}

.demo-kpi-value {
  font-size: 1.7rem;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  color: var(--purple);
}

.demo-kpi-label {
  margin-top: 0.35rem;
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--text);
}

@media (max-width: 1200px) {
  .outbox-sentbox-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 991px) {
  .outbox-challan-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .demo-filter-bar.outbox-legacy-filter-bar--sent {
    flex-wrap: wrap;
  }

  .outbox-sent-filter-fields {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    flex: 1 1 100%;
  }

  .notification-filter-fields,
  .outbox-legacy-filter-fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .outbox-sent-top-row {
    grid-template-columns: 1fr 1fr;
  }

  .outbox-sent-top-row .outbox-sent-search-item {
    grid-column: 1 / -1;
  }

  .outbox-sent-bottom-row {
    grid-template-columns: 1fr 1fr;
  }

  .outbox-sent-bottom-row .outbox-sent-inline-refresh {
    grid-column: 1 / -1;
    width: 100%;
  }

  .notification-kpi-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .outbox-section-title-row {
    align-items: flex-start;
  }

  .pagination-controls-top {
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: center;

    .pagination-count-display {
      order: 3;
      width: 100%;
      margin: 0.35rem 0 0;
      text-align: center;
    }
  }
}

@media (max-width: 767px) {
  .outbox-page {
    margin: -0.5rem -0.5rem 0;
    padding: 0.75rem 0.75rem 1.25rem;
  }

  .outbox-loading-bar {
    margin: -0.75rem -0.75rem 0.85rem;
  }

  .outbox-section-title {
    font-size: 1.15rem;
  }

  .outbox-status-select {
    width: 100%;
    min-width: 0;
  }

  .notification-kpi-grid {
    grid-template-columns: 1fr;
  }

  .demo-filter-bar {
    flex-direction: column;
    align-items: stretch;
    padding: 0.85rem;
  }

  .notification-filter-fields,
  .outbox-legacy-filter-fields {
    grid-template-columns: 1fr;
    width: 100%;
  }

  .outbox-sent-top-row,
  .outbox-sent-bottom-row {
    grid-template-columns: 1fr;
  }

  .outbox-sent-top-row .outbox-sent-search-item {
    grid-column: auto;
  }

  .outbox-sent-bottom-row .outbox-sent-inline-refresh {
    grid-column: auto;
    width: 100%;
  }

  .outbox-legacy-actions {
    width: 100%;
    flex-direction: column;
  }

  .outbox-filter-bar-row {
    flex-wrap: wrap;
  }

  .outbox-filter-right-cluster {
    width: 100%;
    margin-inline-start: 0;
    justify-content: flex-end;
    flex-wrap: wrap;
  }

  .outbox-filter-status {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .outbox-refresh-btn,
  .demo-excel-btn {
    width: 100%;
  }

  .outbox-legacy-actions .outbox-icon-btn-danger {
    width: 100%;
  }

  .outbox-challan-kpi-grid,
  .outbox-sentbox-kpi-grid {
    grid-template-columns: 1fr;
  }

  .demo-table,
  .outbox-table ::v-deep table {
    min-width: 640px;
  }

  .notification-message {
    max-width: 240px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

/*
  Keep outbox teleported menus above table/card content only.
  Must stay below app navbar dropdowns (theme uses z-index ~997+).
*/
body > .vs__dropdown-menu {
  z-index: 1040 !important;
}

body > .flatpickr-calendar.open {
  z-index: 1040 !important;
}
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
